/* Shared catalogue artwork reveal. Both the native carousel and the
   homepage sculpture presentation use this exact transition/event sequence. */
window.AKCarouselExploreReveal = function(section, exploreSlide) {
  window.clearTimeout(section.__akExploreCopyReadyTimer);
  if (section.__akExploreCopyReadyBox && section.__akExploreCopyReadyHandler) {
    section.__akExploreCopyReadyBox.removeEventListener('transitionend', section.__akExploreCopyReadyHandler);
  }
                  section.classList.add(
                    'ak-featured-final-swap-active'
                  );


                  const centerBox =
                    exploreSlide.querySelector(
                      '.ak-featured-explore-center-box'
                    );


                  const revealExploreCopy =
                    function(event) {

                      if (
                        event &&
                        (
                          event.target !== centerBox ||
                          event.propertyName !== 'transform'
                        )
                      ) {
                        return;
                      }


                      window.clearTimeout(
                        section.__akExploreCopyReadyTimer
                      );


                      if (
                        centerBox
                      ) {

                        centerBox.removeEventListener(
                          'transitionend',
                          revealExploreCopy
                        );

                      }


                      section.__akExploreCopyReadyBox =
                        null;


                      section.__akExploreCopyReadyHandler =
                        null;


                      if (
                        section.classList.contains(
                          'ak-featured-final-swap-active'
                        )
                      ) {
                        section.classList.add(
                          'ak-featured-explore-copy-ready'
                        );
                      }

                    };


                  if (
                    centerBox
                  ) {

                    section.__akExploreCopyReadyBox =
                      centerBox;


                    section.__akExploreCopyReadyHandler =
                      revealExploreCopy;


                    centerBox.addEventListener(
                      'transitionend',
                      revealExploreCopy
                    );

                  }


                  /* Safety fallback for browsers that suppress transitionend.
                     It is deliberately later than the complete box drawing. */
                  section.__akExploreCopyReadyTimer =
                    window.setTimeout(
                      revealExploreCopy,
                      1900
                    );
};

/* Shared carousel controller: loaded once, rather than once per section. */

  (function() {

    if (window.__AK_FEATURED_CAROUSEL_CONTROLS_INITIALIZED__) {
      return;
    }

    window.__AK_FEATURED_CAROUSEL_CONTROLS_INITIALIZED__ = true;

    const handleSliders = () => {

      document.querySelectorAll('section.ak-featured-carousel').forEach(function(section) {

        const splideEl = section.querySelector('.splide');
        const splideNext = section.querySelector('.splide__arrow--next');
        const splidePrev = section.querySelector('.splide__arrow--prev');

        const myNext = section.querySelector('.ak-slider-arrow-next');
        const myPrev = section.querySelector('.ak-slider-arrow-prev');

        const list = section.querySelector('.splide__list');
        const track = section.querySelector('.splide__track');

        const desktopWrap = section.querySelector(
          '.ak-slider-nav .mobile-carousel-progress'
        );

        const desktopBar = section.querySelector(
          '.ak-slider-nav .mobile-carousel-progress .ak-mobile-progress-bar'
        );

        const mobileWrap = section.querySelector(
          '.splide > .ak-mobile-progress-box'
        );

        const mobileBar = section.querySelector(
          '.splide > .ak-mobile-progress-box > .ak-mobile-progress-bar'
        );

        if (!splideEl || !list || !track) return;

        function getSplide() {

          return (
            splideEl.splide ||
            splideEl._splide ||
            null
          );

        }

        function getAkDesktopListBaseX() {

          if (
            section.dataset.akDesktopListBaseX !==
              undefined
          ) {

            return parseFloat(
              section.dataset.akDesktopListBaseX
            ) || 0;

          }


          const computedTransform =
            window.getComputedStyle(
              list
            ).transform;


          let baseX =
            0;


          if (
            computedTransform &&
            computedTransform !==
              'none'
          ) {

            try {

              const matrix =
                new DOMMatrix(
                  computedTransform
                );


              baseX =
                matrix.m41;

            } catch (
              error
            ) {

              baseX =
                0;

            }

          }


          section.dataset.akDesktopListBaseX =
            String(
              baseX
            );


          return baseX;

        }


        function moveAkDesktopList(
          targetIndex
        ) {

          if (
            !window.matchMedia(
              '(min-width: 1201px)'
            ).matches
          ) {
            return false;
          }


          const trackWidth =
            track.getBoundingClientRect().width;


          if (
            trackWidth <=
              0
          ) {
            return false;
          }


          const baseX =
            getAkDesktopListBaseX();


          const slideWidth =
            trackWidth /
            4;


          const targetX =
            baseX -
            (
              targetIndex *
              slideWidth
            );


          list.style.setProperty(
            'transition',
            'none',
            'important'
          );


          list.style.setProperty(
            'transform',
            'translate3d(' +
              targetX +
              'px, 0, 0)',
            'important'
          );


          section.dataset.akDesktopCarouselIndex =
            String(
              targetIndex
            );


          return true;

        }


        const grid =
          section.querySelector(
            '.ak-carousel-structural-grid'
          );


        const gridSplide =
          getSplide();


        if (
          gridSplide &&
          grid &&
          !grid.dataset.akGridBound
        ) {
          grid.dataset.akGridBound = 'true';

          gridSplide.on(
            'moved',
            function() {

              grid.classList.remove(
                'ak-carousel-grid-exit'
              );

              grid.classList.add(
                'ak-carousel-grid-enter'
              );

              requestAnimationFrame(function() {

                requestAnimationFrame(function() {

                  grid.classList.remove(
                    'ak-carousel-grid-enter'
                  );

                  grid.classList.add(
                    'ak-carousel-grid-return'
                  );

                });

              });

            }
          );
        }


        function getCarouselState() {

          const paginationButtons =
            Array.from(
              section.querySelectorAll(
                '.splide__pagination__page'
              )
            );

          const realSlides =
            window.matchMedia(
              '(min-width: 1201px)'
            ).matches
              ? section.querySelectorAll(
                  '.splide__slide:not(.splide__slide--clone):not(.ak-featured-explore-slide-mobile)'
                )
              : section.querySelectorAll(
                  '.splide__slide:not(.splide__slide--clone)'
                );

          const visibleSlides =
            window.matchMedia(
              '(min-width: 1201px)'
            ).matches
              ? 4
              : 1;

          const maximumIndex =
            Math.max(
              0,
              realSlides.length - visibleSlides
            );

          const isDesktop =
            window.matchMedia(
              '(min-width: 1201px)'
            ).matches;


          const currentSplide =
            getSplide();


          let currentIndex;


          if (
            isDesktop
          ) {

            currentIndex =
              parseInt(
                section.dataset.akDesktopCarouselIndex ||
                '0',
                10
              );

          } else {

            currentIndex =
              currentSplide &&
              typeof currentSplide.index ===
                'number'
                ? currentSplide.index
                : paginationButtons.findIndex(
                    function(button) {

                      return button.classList.contains(
                        'is-active'
                      );

                    }
                  );

          }


          if (
            currentIndex <
              0
          ) {

            currentIndex =
              0;

          }

          return {
            paginationButtons: paginationButtons,
            currentIndex: currentIndex,
            maximumIndex: maximumIndex
          };

        }

        let akExploreTimers =
          [];


        function resetAkExploreSequence() {

          akExploreTimers.forEach(
            function(
              timer
            ) {

              clearTimeout(
                timer
              );

            }
          );


          akExploreTimers =
            [];


          section.classList.remove(
            'ak-featured-explore-title-visible',
            'ak-featured-explore-box-visible',
            'ak-featured-explore-text-visible',
            'ak-featured-explore-arrow-visible'
          );

        }


        function startAkExploreSequence() {

          resetAkExploreSequence();


          const exploreSlide =
            section.querySelector(
              '[data-ak-featured-explore-slide]'
            );


          if (
            !exploreSlide
          ) {
            return;
          }


          const trackRect =
            track.getBoundingClientRect();


          const exploreRect =
            exploreSlide.getBoundingClientRect();


          const exploreIsVisible =
            exploreRect.left <
              trackRect.right &&
            exploreRect.right >
              trackRect.left;


          if (
            !exploreIsVisible
          ) {
            return;
          }


          /*
            STEP 1

            Collection heading fades into
            the bottom info box first.
          */

          section.classList.add(
            'ak-featured-explore-title-visible'
          );


          /*
            STEP 2

            Arrow box grows upward from
            the bottom of the image area.
          */

          akExploreTimers.push(
            setTimeout(
              function() {

                section.classList.add(
                  'ak-featured-explore-box-visible'
                );

              },
              350
            )
          );


          /*
            STEP 3

            EXPLORE FULL COLLECTION
            fades into the remaining area.
          */

          akExploreTimers.push(
            setTimeout(
              function() {

                section.classList.add(
                  'ak-featured-explore-text-visible'
                );

              },
              950
            )
          );


          /*
            STEP 4

            Long arrow appears last.
          */

          akExploreTimers.push(
            setTimeout(
              function() {

                section.classList.add(
                  'ak-featured-explore-arrow-visible'
                );

              },
              1300
            )
          );

        }

        function getAkFinalExploreIndexes() {

          const realSlides =
            Array.from(
              section.querySelectorAll(
                '.splide__slide:not(.splide__slide--clone):not(.ak-featured-explore-slide-mobile)'
              )
            );


          const finalProductIndex =
            realSlides.findIndex(
              function(
                slide
              ) {

                return slide.hasAttribute(
                  'data-ak-featured-final-product'
                );

              }
            );


          if (
            finalProductIndex <
              0
          ) {

            return null;

          }


          return {

            finalProductIndex:
              finalProductIndex,

            finalProductStartIndex:
              Math.max(
                0,
                finalProductIndex -
                3
              )

          };

        }


        function runAkFinalExploreSwap() {

          if (
            !window.matchMedia(
              '(min-width: 1201px)'
            ).matches
          ) {
            return false;
          }


          if (
            section.dataset.akFinalExploreRunning ===
              'true' ||
            section.classList.contains(
              'ak-featured-final-swap-active'
            )
          ) {
            return true;
          }


          const indexes =
            getAkFinalExploreIndexes();


          const finalProduct =
            section.querySelector(
              '[data-ak-featured-final-product]'
            );


          const exploreSlide =
            section.querySelector(
              '[data-ak-featured-explore-slide]'
            );


          if (
            !indexes ||
            !finalProduct ||
            !exploreSlide
          ) {
            return false;
          }


          const state =
            getCarouselState();


          if (
            state.currentIndex !==
              indexes.finalProductStartIndex
          ) {
            return false;
          }


          section.dataset.akFinalExploreRunning =
            'true';


          window.clearTimeout(
            section.__akExploreCopyReadyTimer
          );


          if (
            section.__akExploreCopyReadyBox &&
            section.__akExploreCopyReadyHandler
          ) {

            section.__akExploreCopyReadyBox.removeEventListener(
              'transitionend',
              section.__akExploreCopyReadyHandler
            );

          }


          section.__akExploreCopyReadyBox =
            null;


          section.__akExploreCopyReadyHandler =
            null;


          section.classList.remove(
            'ak-featured-explore-copy-ready'
          );


          resetAkExploreSequence();


          const finalInfo =
            finalProduct.querySelector(
              '.relative.py-4'
            );


          section.classList.add(
            'ak-featured-final-swap-running'
          );


          requestAnimationFrame(
            function() {

              requestAnimationFrame(
                function() {

                  if (
                    finalInfo
                  ) {

                    finalInfo.classList.add(
                      'ak-final-product-info-hidden'
                    );

                  }


                  window.AKCarouselExploreReveal(section, exploreSlide);

                }
              );

            }
          );


          setTimeout(
            function() {

              section.classList.add(
                'ak-featured-final-swap-complete'
              );


              section.dataset.akFinalExploreRunning =
                'false';


              startAkExploreSequence();

            },
            900
          );


          return true;

        }


        function resetAkFinalExploreSwap() {

          if (
            !window.matchMedia(
              '(min-width: 1201px)'
            ).matches
          ) {
            return false;
          }


          if (
            !section.classList.contains(
              'ak-featured-final-swap-active'
            )
          ) {
            return false;
          }


          if (
            section.dataset.akFinalExploreRunning ===
              'true'
          ) {
            return true;
          }


          section.dataset.akFinalExploreRunning =
            'true';


          resetAkExploreSequence();


          window.clearTimeout(
            section.__akExploreCopyReadyTimer
          );


          if (
            section.__akExploreCopyReadyBox &&
            section.__akExploreCopyReadyHandler
          ) {

            section.__akExploreCopyReadyBox.removeEventListener(
              'transitionend',
              section.__akExploreCopyReadyHandler
            );

          }


          section.__akExploreCopyReadyBox =
            null;


          section.__akExploreCopyReadyHandler =
            null;


          section.classList.remove(
            'ak-featured-explore-copy-ready'
          );


          section.classList.remove(
            'ak-featured-final-swap-complete'
          );


          section.classList.remove(
            'ak-featured-final-swap-active'
          );


          setTimeout(
            function() {

              section.classList.remove(
                'ak-featured-final-swap-running'
              );


              const finalProduct =
                section.querySelector(
                  '[data-ak-featured-final-product]'
                );


              const finalInfo =
                finalProduct
                  ? finalProduct.querySelector(
                      '.relative.py-4'
                    )
                  : null;


              if (
                finalInfo
              ) {

                finalInfo.classList.remove(
                  'ak-final-product-info-hidden'
                );

              }


              section.dataset.akFinalExploreRunning =
                'false';

            },
            900
          );


          return true;

        }

        function clearAkFinalExploreSwapInstant() {

          section.classList.add(
            'ak-featured-final-swap-instant-reset'
          );


          resetAkExploreSequence();


          window.clearTimeout(
            section.__akExploreCopyReadyTimer
          );


          if (
            section.__akExploreCopyReadyBox &&
            section.__akExploreCopyReadyHandler
          ) {

            section.__akExploreCopyReadyBox.removeEventListener(
              'transitionend',
              section.__akExploreCopyReadyHandler
            );

          }


          section.__akExploreCopyReadyBox =
            null;


          section.__akExploreCopyReadyHandler =
            null;


          section.classList.remove(
            'ak-featured-final-swap-complete',
            'ak-featured-final-swap-active',
            'ak-featured-final-swap-running',
            'ak-featured-explore-copy-ready'
          );


          const finalProduct =
            section.querySelector(
              '[data-ak-featured-final-product]'
            );


          const finalInfo =
            finalProduct
              ? finalProduct.querySelector(
                  '.relative.py-4'
                )
              : null;


          if (
            finalInfo
          ) {

            finalInfo.classList.remove(
              'ak-final-product-info-hidden'
            );

          }


          section.dataset.akFinalExploreRunning =
            'false';


          section.offsetHeight;


          section.classList.remove(
            'ak-featured-final-swap-instant-reset'
          );

        }


        function scheduleAkAutomaticFinalExplore() {

          if (
            !window.matchMedia(
              '(min-width: 1201px)'
            ).matches
          ) {
            return;
          }


          if (
            section.dataset.akFinalExploreRunning ===
              'true' ||
            section.classList.contains(
              'ak-featured-final-swap-active'
            )
          ) {
            return;
          }


          const indexes =
            getAkFinalExploreIndexes();


          if (
            !indexes
          ) {
            return;
          }


          const state =
            getCarouselState();


          if (
            state.currentIndex !==
              indexes.finalProductStartIndex
          ) {
            return;
          }


          setTimeout(
            function() {

              if (
                section.dataset.akCoverRunning ===
                  'true'
              ) {
                return;
              }


              const currentState =
                getCarouselState();


              if (
                currentState.currentIndex !==
                  indexes.finalProductStartIndex
              ) {
                return;
              }


              runAkFinalExploreSwap();

            },
            120
          );

        }


        function animateGridAndMove(
          targetIndex,
          resetFinalExplore
        ) {


          const grid =
            section.querySelector(
              '.ak-carousel-structural-grid'
            );

          const imageCover =
            section.querySelector(
              '.ak-carousel-image-cover'
            );

          const priceBoxes =
            section.querySelectorAll(
              '.relative.py-4'
            );

          if (
            !grid ||
            !imageCover ||
            typeof targetIndex !==
              'number' ||
            section.dataset.akCoverRunning ===
              'true'
          ) {
            return;
          }


          section.dataset.akCoverRunning =
            'true';


          resetAkExploreSequence();


          section.classList.add(
            'ak-desktop-cover-ready',
            'ak-desktop-image-ready'
          );


          imageCover.classList.add(
            'ak-desktop-door-image-visible'
          );


          /*
            IMPORTANT:

            PREV / NEXT DOORS MUST ALWAYS WORK,
            ALSO AFTER THE PAGE INTRO HAS
            ALREADY PLAYED THIS VISIT.

            Therefore every click starts from
            a completely clean OPEN door state.
          */

          imageCover.classList.remove(
            'ak-carousel-cover-closing',
            'ak-carousel-cover-closed',
            'ak-carousel-cover-opening'
          );


          /*
            Force the browser to commit the
            open state before starting the
            closing animation.
          */

          imageCover.offsetHeight;


          grid.classList.remove(
            'ak-carousel-grid-enter',
            'ak-carousel-grid-return'
          );

          grid.classList.add(
            'ak-carousel-grid-exit'
          );


          requestAnimationFrame(
            function() {

              requestAnimationFrame(
                function() {

                  imageCover.classList.add(
                    'ak-carousel-cover-closing'
                  );


                  priceBoxes.forEach(
                    function(
                      priceBox
                    ) {

                      priceBox.classList.add(
                        'ak-carousel-price-hidden'
                      );

                    }
                  );

                }
              );

            }
          );


          setTimeout(
            function() {

              imageCover.classList.remove(
                'ak-carousel-cover-closing'
              );

              imageCover.classList.add(
                'ak-carousel-cover-closed'
              );


              let hasOpened =
                false;


              const openCover =
                function() {

                  if (
                    hasOpened
                  ) {
                    return;
                  }


                  hasOpened =
                    true;


                  /*
                    Keep the doors completely
                    closed a little longer after
                    Splide has finished moving.

                    This gives the browser time
                    to paint the new slide before
                    the doors start opening.
                  */

                  setTimeout(
                    function() {

                      requestAnimationFrame(
                        function() {

                          requestAnimationFrame(
                            function() {

                              imageCover.classList.remove(
                                'ak-carousel-cover-closed'
                              );

                              imageCover.classList.add(
                                'ak-carousel-cover-opening'
                              );


                              /*
                                Keep product / price text hidden
                                during the first part of the
                                opening animation.

                                This prevents the previous slide
                                text from flashing through.
                              */

                              setTimeout(
                                function() {

                                  priceBoxes.forEach(
                                    function(
                                      priceBox
                                    ) {

                                      priceBox.classList.remove(
                                        'ak-carousel-price-hidden'
                                      );

                                    }
                                  );

                                },
                                100
                              );


                              setTimeout(
                                function() {

                                  imageCover.classList.remove(
                                    'ak-carousel-cover-opening'
                                  );


                                  /*
                                    Doors are now fully open.

                                    EXPLORE may only start
                                    from this point.
                                  */

                                  startAkExploreSequence();


                                  grid.classList.remove(
                                    'ak-carousel-grid-exit'
                                  );

                                  grid.classList.add(
                                    'ak-carousel-grid-enter'
                                  );


                                  requestAnimationFrame(
                                    function() {

                                      requestAnimationFrame(
                                        function() {

                                          grid.classList.remove(
                                            'ak-carousel-grid-enter'
                                          );

                                          grid.classList.add(
                                            'ak-carousel-grid-return'
                                          );

                                        }
                                      );

                                    }
                                  );


                                  section.dataset.akCoverRunning =
                                    'false';


                                  scheduleAkAutomaticFinalExplore();

                                },
                                760
                              );

                            }
                          );

                        }
                      );

                    },
                    220
                  );

                };


              const isDesktop =
                window.matchMedia(
                  '(min-width: 1201px)'
                ).matches;


              if (
                isDesktop
              ) {

                if (
                  resetFinalExplore ===
                    true
                ) {

                  clearAkFinalExploreSwapInstant();

                }


                moveAkDesktopList(
                  targetIndex
                );


                requestAnimationFrame(
                  function() {

                    requestAnimationFrame(
                      function() {

                        openCover();

                      }
                    );

                  }
                );

              } else {

                const currentSplide =
                  getSplide();


                if (
                  currentSplide
                ) {

                  currentSplide.once(
                    'moved',
                    function() {

                      openCover();

                    }
                  );

                }


                if (
                  currentSplide &&
                  typeof currentSplide.go ===
                    'function'
                ) {

                  currentSplide.go(
                    targetIndex
                  );

                } else {

                  const fallbackButton =
                    section.querySelectorAll(
                      '.splide__pagination__page'
                    )[
                      targetIndex
                    ];


                  if (
                    fallbackButton
                  ) {

                    fallbackButton.click();

                  }

                }


                setTimeout(
                  function() {

                    openCover();

                  },
                  500
                );

              }

            },
            760
          );

        }


        if (
          myNext &&
          !myNext.dataset.akBound
        ) {

          myNext.dataset.akBound =
            'true';


          myNext.addEventListener(
            'click',
            function(e) {

              e.preventDefault();


              if (
                section.dataset.akFinalExploreRunning ===
                  'true'
              ) {
                return;
              }


              /*
                EXPLORE is already open.

                There is nowhere further to move.
              */

              if (
                window.matchMedia(
                  '(min-width: 1201px)'
                ).matches &&
                section.classList.contains(
                  'ak-featured-final-swap-active'
                )
              ) {
                return;
              }


              const state =
                getCarouselState();


              const indexes =
                getAkFinalExploreIndexes();


              if (
                window.matchMedia(
                  '(min-width: 1201px)'
                ).matches &&
                indexes
              ) {

                /*
                  Normal NEXT movement may only go as
                  far as:

                  5 | 6 | 7 | 8

                  Once that movement has completed,
                  scheduleAkAutomaticFinalExplore()
                  automatically continues to:

                  6 | 7 | 8 | EXPLORE
                */

                const targetIndex =
                  Math.min(
                    state.currentIndex +
                    4,
                    indexes.finalProductStartIndex
                  );


                if (
                  targetIndex ===
                    state.currentIndex
                ) {

                  scheduleAkAutomaticFinalExplore();

                  return;

                }


                updateProgress(
                  targetIndex
                );


                animateGridAndMove(
                  targetIndex
                );


                return;

              }


              const targetIndex =
                Math.min(
                  state.currentIndex +
                  4,
                  state.maximumIndex
                );


              if (
                targetIndex ===
                  state.currentIndex
              ) {
                return;
              }


              updateProgress(
                targetIndex
              );


              animateGridAndMove(
                targetIndex
              );

            }
          );

        }


        if (
          myPrev &&
          !myPrev.dataset.akBound
        ) {

          myPrev.dataset.akBound =
            'true';


          myPrev.addEventListener(
            'click',
            function(e) {

              e.preventDefault();


              if (
                section.dataset.akFinalExploreRunning ===
                  'true'
              ) {
                return;
              }


              if (
                window.matchMedia(
                  '(min-width: 1201px)'
                ).matches &&
                section.classList.contains(
                  'ak-featured-final-swap-active'
                )
              ) {

                resetAkFinalExploreSwap();


                return;

              }


              const state =
                getCarouselState();


              const targetIndex =
                Math.max(
                  0,
                  state.currentIndex -
                  4
                );


              if (
                targetIndex ===
                state.currentIndex
              ) {
                return;
              }


              updateProgress(
                targetIndex
              );


              animateGridAndMove(
                targetIndex
              );

            }
          );

        }


        function updateProgress(
          forcedIndex,
          immediate
        ) {

          const isDesktopProgress =
            window.matchMedia(
              '(min-width: 1201px)'
            ).matches;


          const realSlideCount =
            section.querySelectorAll(
              '.splide__slide:not(.splide__slide--clone)'
            ).length;


          const totalSlides =
            isDesktopProgress
              ? realSlideCount
              : Math.min(
                  6,
                  realSlideCount
                );


          if (
            totalSlides <=
              0
          ) {
            return;
          }


          const visibleSlides =
            isDesktopProgress
              ? 4
              : 1;


          const maximumIndex =
            Math.max(
              0,
              totalSlides -
              visibleSlides
            );


          let currentIndex =
            0;


          if (
            typeof forcedIndex ===
              'number'
          ) {

            currentIndex =
              forcedIndex;

          } else {

            const state =
              getCarouselState();


            currentIndex =
              state.currentIndex;

          }


          currentIndex =
            Math.max(
              0,
              Math.min(
                currentIndex,
                maximumIndex
              )
            );


          section.dataset.akProgressIndex =
            String(
              currentIndex
            );


          const ratio =
            maximumIndex >
              0
              ? currentIndex /
                maximumIndex
              : 0;


          function moveBar(
            wrap,
            bar
          ) {

            if (
              !wrap ||
              !bar
            ) {
              return;
            }


            const wrapWidth =
              wrap.clientWidth;


            if (
              wrapWidth <=
                0
            ) {
              return;
            }


            const barWidth =
              wrapWidth *
              Math.min(
                1,
                visibleSlides /
                totalSlides
              );


            const maxMove =
              Math.max(
                0,
                wrapWidth -
                barWidth
              );


            const targetX =
              maxMove *
              ratio;


            if (
              bar._akProgressFrame
            ) {

              cancelAnimationFrame(
                bar._akProgressFrame
              );


              bar._akProgressFrame =
                null;

            }


            const startX =
              typeof bar._akProgressX ===
                'number'
                ? bar._akProgressX
                : 0;


            bar.style.setProperty(
              'width',
              barWidth + 'px',
              'important'
            );


            bar.style.setProperty(
              'transition',
              'none',
              'important'
            );


            if (
              immediate ===
                true
            ) {

              bar._akProgressX =
                targetX;


              bar.style.setProperty(
                'transform',
                'translate3d(' +
                  targetX +
                  'px, 0, 0)',
                'important'
              );


              return;

            }


            const duration =
              isDesktopProgress
                ? 760
                : 260;


            const startTime =
              performance.now();


            function animateBar(
              now
            ) {

              const elapsed =
                now -
                startTime;


              const rawProgress =
                Math.min(
                  1,
                  elapsed /
                    duration
                );


              const easedProgress =
                1 -
                Math.pow(
                  1 -
                    rawProgress,
                  3
                );


              const currentX =
                startX +
                (
                  targetX -
                  startX
                ) *
                easedProgress;


              bar._akProgressX =
                currentX;


              bar.style.setProperty(
                'transform',
                'translate3d(' +
                  currentX +
                  'px, 0, 0)',
                'important'
              );


              if (
                rawProgress <
                  1
              ) {

                bar._akProgressFrame =
                  requestAnimationFrame(
                    animateBar
                  );

              } else {

                bar._akProgressX =
                  targetX;


                bar._akProgressFrame =
                  null;

              }

            }


            bar._akProgressFrame =
              requestAnimationFrame(
                animateBar
              );

          }


          moveBar(
            desktopWrap,
            desktopBar
          );


          moveBar(
            mobileWrap,
            mobileBar
          );

        }


        if (
          !section.dataset.akProgressResizeBound
        ) {

          section.dataset.akProgressResizeBound =
            'true';


          window.addEventListener(
            'resize',
            function() {

              requestAnimationFrame(
                function() {

                  updateProgress();

                }
              );

            },
            {
              passive: true
            }
          );

        }


        const progressSplide =
          getSplide();

        function syncAkMobileSlideLimit() {

          const isMobile =
            window.matchMedia(
              '(max-width: 1200px)'
            ).matches;


          if (
            !section._akMobileExtraSlides
          ) {
            section._akMobileExtraSlides =
              [];
          }


          if (
            isMobile
          ) {

            if (
              section._akMobileExtraSlides.length
            ) {
              return;
            }


            const realSlides =
              Array.from(
                list.children
              ).filter(
                function(
                  slide
                ) {

                  return (
                    slide.classList.contains(
                      'splide__slide'
                    ) &&
                    !slide.classList.contains(
                      'splide__slide--clone'
                    )
                  );

                }
              );


            if (
              realSlides.length <=
                6
            ) {
              return;
            }


            const firstExtraSlide =
              realSlides[6];


            section._akMobileSlideLimitAnchor =
              document.createComment(
                'ak-mobile-slide-limit'
              );


            list.insertBefore(
              section._akMobileSlideLimitAnchor,
              firstExtraSlide
            );


            realSlides
              .slice(
                6
              )
              .forEach(
                function(
                  slide
                ) {

                  section._akMobileExtraSlides.push(
                    slide
                  );


                  slide.remove();

                }
              );


            const currentSplide =
              getSplide();


            if (
              currentSplide &&
              typeof currentSplide.refresh ===
                'function'
            ) {
              currentSplide.refresh();
            }


            return;

          }


          if (
            !section._akMobileExtraSlides.length
          ) {
            return;
          }


          const anchor =
            section._akMobileSlideLimitAnchor;


          section._akMobileExtraSlides.forEach(
            function(
              slide
            ) {

              if (
                anchor &&
                anchor.parentNode ===
                  list
              ) {

                list.insertBefore(
                  slide,
                  anchor
                );

              } else {

                list.appendChild(
                  slide
                );

              }

            }
          );


          section._akMobileExtraSlides =
            [];


          if (
            anchor &&
            anchor.parentNode ===
              list
          ) {
            anchor.remove();
          }


          section._akMobileSlideLimitAnchor =
            null;


          const currentSplide =
            getSplide();


          if (
            currentSplide &&
            typeof currentSplide.refresh ===
              'function'
          ) {
            currentSplide.refresh();
          }

        }


        syncAkMobileSlideLimit();


        window.addEventListener(
          'resize',
          syncAkMobileSlideLimit
        );


        /*
          Mobile has one gesture owner only.

          Splide is still mounted for the existing carousel state and desktop
          controls, but its drag listener must not swallow real iOS gestures
          after the intro. Capture the first meaningful move before Splide:
          vertical movement remains native page scroll, while horizontal
          movement drives the native track and snaps to a complete slide.
        */

        if (
          !section.dataset.akMobileNativeTouchBound
        ) {

          section.dataset.akMobileNativeTouchBound =
            'true';


          let akTouchStartX = 0;
          let akTouchStartY = 0;
          let akTouchStartScrollLeft = 0;
          let akTouchAxis = '';
          let akTouchLastX = 0;
          let akTouchStartIndex = 0;


          track.addEventListener(
            'touchstart',
            function(event) {

              if (
                !window.matchMedia(
                  '(max-width: 1200px)'
                ).matches ||
                event.touches.length !== 1
              ) {
                return;
              }


              const touch = event.touches[0];


              akTouchStartX = touch.clientX;
              akTouchStartY = touch.clientY;
              akTouchLastX = touch.clientX;
              akTouchStartScrollLeft = track.scrollLeft;
              akTouchStartIndex = Math.round(
                track.scrollLeft /
                Math.max(
                  1,
                  track.clientWidth
                )
              );
              akTouchAxis = '';


              /* Follow the finger immediately. Smooth scrolling and CSS
                 snapping are restored only after the target slide is known. */
              track.style.setProperty(
                'scroll-behavior',
                'auto',
                'important'
              );


              track.style.setProperty(
                'scroll-snap-type',
                'none',
                'important'
              );

            },
            {
              passive: true,
              capture: true
            }
          );


          track.addEventListener(
            'touchmove',
            function(event) {

              if (
                !window.matchMedia(
                  '(max-width: 1200px)'
                ).matches ||
                event.touches.length !== 1
              ) {
                return;
              }


              const touch = event.touches[0];
              const deltaX = touch.clientX - akTouchStartX;
              const deltaY = touch.clientY - akTouchStartY;


              akTouchLastX = touch.clientX;


              if (
                !akTouchAxis &&
                Math.max(
                  Math.abs(deltaX),
                  Math.abs(deltaY)
                ) >= 4
              ) {

                akTouchAxis =
                  Math.abs(deltaX) >
                    Math.abs(deltaY) * 0.85
                    ? 'x'
                    : 'y';

              }


              if (
                !akTouchAxis
              ) {
                return;
              }


              event.stopImmediatePropagation();


              if (
                akTouchAxis === 'y'
              ) {
                return;
              }


              event.preventDefault();


              track.scrollLeft =
                Math.max(
                  0,
                  Math.min(
                    akTouchStartScrollLeft - deltaX,
                    track.scrollWidth - track.clientWidth
                  )
                );

            },
            {
              passive: false,
              capture: true
            }
          );


          track.addEventListener(
            'touchend',
            function(event) {

              if (
                !window.matchMedia(
                  '(max-width: 1200px)'
                ).matches ||
                akTouchAxis !== 'x'
              ) {

                track.style.removeProperty(
                  'scroll-behavior'
                );


                track.style.removeProperty(
                  'scroll-snap-type'
                );

                akTouchAxis = '';
                return;
              }


              event.stopImmediatePropagation();


              const slide =
                list.querySelector(
                  '.splide__slide:not(.splide__slide--clone)'
                );


              const slideWidth =
                slide
                  ? slide.getBoundingClientRect().width
                  : track.clientWidth;


              if (
                slideWidth > 0
              ) {

                const totalDeltaX =
                  akTouchLastX - akTouchStartX;


                const swipeThreshold =
                  Math.min(
                    12,
                    slideWidth * 0.04
                  );


                let targetIndex =
                  Math.round(
                    track.scrollLeft / slideWidth
                  );


                if (
                  Math.abs(totalDeltaX) >= swipeThreshold
                ) {

                  targetIndex =
                    akTouchStartIndex +
                    (
                      totalDeltaX < 0
                        ? 1
                        : -1
                    );

                }


                const maximumIndex =
                  Math.max(
                    0,
                    Math.round(
                      (
                        track.scrollWidth -
                        track.clientWidth
                      ) /
                      slideWidth
                    )
                  );


                targetIndex =
                  Math.max(
                    0,
                    Math.min(
                      targetIndex,
                      maximumIndex
                    )
                  );

                track.scrollTo({
                  left:
                    targetIndex * slideWidth,
                  behavior: 'smooth'
                });

              }


              window.setTimeout(
                function() {

                  track.style.removeProperty(
                    'scroll-behavior'
                  );


                  track.style.removeProperty(
                    'scroll-snap-type'
                  );

                },
                420
              );


              akTouchAxis = '';

            },
            {
              passive: true,
              capture: true
            }
          );


          track.addEventListener(
            'touchcancel',
            function() {

              track.style.removeProperty(
                'scroll-behavior'
              );


              track.style.removeProperty(
                'scroll-snap-type'
              );


              akTouchAxis = '';

            },
            {
              passive: true,
              capture: true
            }
          );

        }


        if (
          !section.dataset.akMobileProgressFollowBound
        ) {

          section.dataset.akMobileProgressFollowBound =
            'true';


          let akMobileProgressFrame =
            null;


          function getAkMobileListX() {

            /* Mobile uses the track's native scroll position. This remains
               reliable in iOS Safari after the intro has collapsed or the
               browser tab has been restored, whereas Splide's retained
               transform can be visually present but no longer draggable. */
            if (
              window.matchMedia(
                '(max-width: 1200px)'
              ).matches &&
              track.scrollWidth >
                track.clientWidth
            ) {
              return -track.scrollLeft;
            }

            const transform =
              window.getComputedStyle(
                list
              ).transform;


            if (
              !transform ||
              transform ===
                'none'
            ) {
              return 0;
            }


            try {

              const matrix =
                new DOMMatrix(
                  transform
                );


              return matrix.m41;

            } catch (
              error
            ) {

              return 0;

            }

          }


          function syncAkMobileProgressFromList() {

            akMobileProgressFrame =
              null;

            if (
              !window.matchMedia(
                '(max-width: 1200px)'
              ).matches
            ) {

              if (
                akMobileProgressFrame
              ) {

                cancelAnimationFrame(
                  akMobileProgressFrame
                );


                akMobileProgressFrame =
                  null;

              }


              return;

            }


            if (
              !mobileWrap ||
              !mobileBar
            ) {

              return;

            }


            const realSlides =
              Array.from(
                list.children
              ).filter(
                function(
                  slide
                ) {

                  return (
                    slide.classList.contains(
                      'splide__slide'
                    ) &&
                    !slide.classList.contains(
                      'splide__slide--clone'
                    )
                  );

                }
              );


            const totalSlides =
              Math.min(
                6,
                realSlides.length
              );


            if (
              totalSlides <=
                1
            ) {
              return;

            }


            const firstSlide =
              realSlides[0];


            const slideWidth =
              firstSlide
                .getBoundingClientRect()
                .width;


            if (
              slideWidth <=
                0
            ) {
              return;

            }


            /*
              Splide's list transform is the source
              of truth.

              0px        = slide 1
              -1 width   = slide 2
              -2 widths  = slide 3
              etc.
            */


            const continuousIndex =
              track.scrollLeft /
              slideWidth;


            const maximumIndex =
              totalSlides -
              1;


            const clampedIndex =
              Math.max(
                0,
                Math.min(
                  continuousIndex,
                  maximumIndex
                )
              );


            const wrapWidth =
              mobileWrap
                .getBoundingClientRect()
                .width;


            if (
              wrapWidth <=
                0
            ) {
              return;

            }


            const barWidth =
              (
                wrapWidth /
                totalSlides
              ) *
              1.6;


            const maxMove =
              wrapWidth -
              barWidth;


            const ratio =
              clampedIndex /
              maximumIndex;


            const moveAmount =
              maxMove *
              ratio;


            if (
              mobileBar._akProgressFrame
            ) {

              cancelAnimationFrame(
                mobileBar._akProgressFrame
              );


              mobileBar._akProgressFrame =
                null;

            }


            /* The progress UI is a sibling of the native scroll track, so it
               remains geometrically fixed while the indicator follows the
               continuous scroll position without a counter-transform. */
            mobileWrap.style.setProperty(
              'transform',
              'none',
              'important'
            );


            mobileBar.style.setProperty(
              'transition',
              'none',
              'important'
            );


            mobileBar.style.setProperty(
              'width',
              barWidth + 'px',
              'important'
            );


            mobileBar.style.setProperty(
              'transform',
              'translate3d(' +
                moveAmount +
                'px, 0, 0)',
              'important'
            );


            section.dataset.akProgressIndex =
              String(
                clampedIndex
              );


            const activeIndex =
              Math.max(
                0,
                Math.min(
                  Math.round(
                    continuousIndex
                  ),
                  totalSlides - 1
                )
              );


            realSlides.forEach(
              function(
                slide,
                index
              ) {

                const isActive =
                  index === activeIndex;


                slide.classList.toggle(
                  'is-active',
                  isActive
                );


                slide.classList.toggle(
                  'is-visible',
                  isActive
                );


                slide.setAttribute(
                  'aria-hidden',
                  isActive
                    ? 'false'
                    : 'true'
                );

              }
            );

          }


          function queueAkMobileProgressSync() {

            if (
              akMobileProgressFrame
            ) {
              return;
            }


            akMobileProgressFrame =
              requestAnimationFrame(
                syncAkMobileProgressFromList
              );

          }


          function resetAkMobileCarousel() {

            if (
              !window.matchMedia(
                '(max-width: 1200px)'
              ).matches
            ) {
              return;
            }


            // Restoring must be immediate, even though normal swipes use smooth scroll.
            const previousScrollBehavior = track.style.getPropertyValue('scroll-behavior');
            const previousScrollPriority = track.style.getPropertyPriority('scroll-behavior');
            track.style.setProperty('scroll-behavior', 'auto', 'important');

            const currentSplide =
              getSplide();


            if (
              currentSplide &&
              typeof currentSplide.go ===
                'function' &&
              currentSplide.index !== 0
            ) {

              currentSplide.go(
                0
              );

            }


            if (currentSplide && currentSplide.Components && currentSplide.Components.Move) {
              currentSplide.Components.Move.cancel();
              currentSplide.Components.Move.jump(0);
            }
            list.style.setProperty('transform', 'translateX(0px)');
            list.querySelectorAll('.ak-mobile-fifth-explore-complete').forEach(function (slide) {
              slide.classList.remove('ak-mobile-fifth-explore-complete');
            });

            track.scrollTo({
              left: 0,
              behavior: 'auto'
            });


            track.scrollLeft =
              0;


            requestAnimationFrame(function () {
              if (previousScrollBehavior) {
                track.style.setProperty('scroll-behavior', previousScrollBehavior, previousScrollPriority);
              } else {
                track.style.removeProperty('scroll-behavior');
              }
            });

            delete section.dataset.akMobileProgressBaseX;


            queueAkMobileProgressSync();

          }


          track.addEventListener(
            'scroll',
            queueAkMobileProgressSync,
            {
              passive: true
            }
          );


          if (
            typeof ResizeObserver !==
              'undefined'
          ) {

            const akMobileProgressResizeObserver =
              new ResizeObserver(
                queueAkMobileProgressSync
              );


            akMobileProgressResizeObserver.observe(
              track
            );

          }


          if (
            window.matchMedia(
              '(max-width: 1200px)'
            ).matches
          ) {

            requestAnimationFrame(
              function() {

                requestAnimationFrame(
                  function() {

                    resetAkMobileCarousel();

                  }
                );

              }
            );

          }


          window.addEventListener(
            'resize',
            function() {

              delete section.dataset.akMobileProgressBaseX;


              queueAkMobileProgressSync();

            },
            {
              passive:
                true
            }
          );


          window.addEventListener('ak:mobile-home-resume', queueAkMobileProgressSync);
          window.addEventListener('ak:home-sticky-stage-landed', resetAkMobileCarousel);

          // Native mobile scrolling owns the selected card. Browser resume
          // only repaints/synchronises it; it must never jump back to index 0.
          window.addEventListener('pageshow', queueAkMobileProgressSync, {passive:true});


          window.setTimeout(
            resetAkMobileCarousel,
            120
          );

        }


        requestAnimationFrame(
          function() {

            requestAnimationFrame(
              function() {

                updateProgress();

              }
            );

          }
        );

      });

    };


    const queueAkFeaturedCarouselControls = () => {

      const run = () => {

        requestAnimationFrame(
          function() {

            requestAnimationFrame(
              handleSliders
            );

          }
        );

      };


      if (
        typeof window.requestIdleCallback ===
        'function'
      ) {

        window.requestIdleCallback(
          run,
          {
            timeout:
              700
          }
        );

      } else {

        run();

      }

    };


    const initializeAkFeaturedCarouselControls = () => {

      const homeFilm =
        document.querySelector(
          '.ak-film-simple-section'
        );


      // Inner-page arrivals skip the film but retain its hidden DOM section.
      // Waiting for its removal event would leave native scroll/reset unbound.
      if (homeFilm && !(window.AK_HOME_INTRO && window.AK_HOME_INTRO.playVideo === false)) {

        window.addEventListener(
          'ak:film-removed',
          queueAkFeaturedCarouselControls,
          {
            once:
              true
          }
        );

        return;

      }


      queueAkFeaturedCarouselControls();


      setTimeout(
        handleSliders,
        500
      );


      setTimeout(
        handleSliders,
        1500
      );

    };


    if (
      document.readyState ===
      'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        initializeAkFeaturedCarouselControls,
        {
          once:
            true
        }
      );

    } else {

      initializeAkFeaturedCarouselControls();

    }


    document.addEventListener(
      'shopify:section:load',
      handleSliders
    );


  })();


(function () {

  if (window.__AK_FEATURED_CAROUSEL_REVEAL_INITIALIZED__) {
    return;
  }

  window.__AK_FEATURED_CAROUSEL_REVEAL_INITIALIZED__ = true;

  if (document.body.classList.contains('ak-papers-editorial-page')) {
    window.addEventListener('ak:papers-editorial-cta-ready', function (event) {
      if (event.detail && event.detail.section) {
        openAkDesktopInitialCover(event.detail.section, true);
      }
    });
  }

  /* =====================================================
     DESKTOP INITIAL COVER
  ===================================================== */

  function openAkDesktopInitialCover(
    section, centerGateReached
  ) {
    if(document.documentElement.classList.contains('ak-carousel-page-revisit')) {
      window.akCommitCarouselRevisit(section);
      return;
    }

    // On desktop Papers Front, the lower CTA's arriving line owns the
    // shutter release. Generic viewport observers may prepare, never preempt it.
    if (section && document.body.classList.contains('ak-papers-editorial-page') &&
        !section.classList.contains('ak-paper-cta-ready')) return;

    if (
      !section ||
      !window.matchMedia(
        '(min-width: 1201px)'
      ).matches
    ) {
      return;
    }


    // Every later carousel keeps its closed artwork until its centre
    // reaches 65% of the viewport height. All initial-reveal callers use this gate.
    if (!centerGateReached &&
        (document.body.classList.contains('ak-papers-editorial-page') ||
         section !== document.querySelector('section.ak-featured-carousel')) &&
        section.dataset.akInitialCoverOpened !== 'true') {
      var bounds = section.getBoundingClientRect();
      if (bounds.top + bounds.height / 2 > window.innerHeight * 0.65) {
        if (section.dataset.akInitialCoverCenterQueued !== 'true') {
          section.dataset.akInitialCoverCenterQueued = 'true';
          var midpoint = document.createElement('span');
          midpoint.setAttribute('aria-hidden', 'true');
          midpoint.style.cssText = 'position:absolute;top:50%;left:50%;width:1px;height:1px;pointer-events:none';
          section.appendChild(midpoint);
          var observer;
          function observeMidpoint() {
            if (observer) observer.disconnect();
            observer = new IntersectionObserver(function (entries) {
              if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
              observer.disconnect();
              window.removeEventListener('resize', observeMidpoint);
              midpoint.remove();
              section.dataset.akInitialCoverCenterQueued = 'false';
              // IntersectionObserver already measured the centre gate; do not flush layout again.
              openAkDesktopInitialCover(section, true);
            }, { rootMargin: '0px 0px -' + Math.round(window.innerHeight * 0.35) + 'px 0px', threshold: 0 });
            observer.observe(midpoint);
          }
          observeMidpoint();
          window.addEventListener('resize', observeMidpoint, { passive: true });
        }
        return;
      }
    }

    if (
      section.dataset.akInitialCoverOpened ===
      'true'
    ) {
      return;
    }


    var track =
      section.querySelector(
        '.splide__track'
      );

    var imageCover =
      section.querySelector(
        '.ak-carousel-image-cover'
      );


    if (
      !track ||
      !imageCover
    ) {
      return;
    }


    section.dataset.akInitialCoverOpened =
      'true';


    imageCover.classList.remove(
      'ak-carousel-cover-closing',
      'ak-carousel-cover-opening'
    );


    imageCover.classList.add(
      'ak-carousel-cover-closed'
    );


    var hasOpened =
      false;


    function openCover() {

      if (
        hasOpened
      ) {
        return;
      }


      hasOpened =
        true;


      /*
        Keep the four full-size Astrobear image animations dormant through
        the complete intro, carousel rise, top-control split and door move.
        The breathing starts only when the opening panel has finished its
        transform. The timeout is only a safety net for interrupted
        transitionend events.
      */

      if (
        section.classList.contains(
          'ak-home-first-featured'
        )
      ) {

        var breathingReleased =
          false;


        function releaseAstrobearBreathing() {

          if (
            breathingReleased
          ) {
            return;
          }


          /* The desktop homepage sticky-stage sequence owns the visible
             door opening and releases breathing when those doors finish. */
          if (
            document.documentElement.classList.contains(
              'ak-home-sticky-stage-enabled'
            )
          ) {
            return;
          }


          breathingReleased =
            true;


          section.classList.add(
            'ak-astrobear-breathing-ready'
          );

        }


        var openingPanel =
          imageCover.querySelector(
            '.ak-carousel-image-cover-top'
          );


        if (
          openingPanel
        ) {

          openingPanel.addEventListener(
            'transitionend',
            releaseAstrobearBreathing,
            {
              once:
                true
            }
          );

        }


        setTimeout(
          releaseAstrobearBreathing,
          920
        );

      }


      /* Commit the fully closed door geometry before changing to the opening
         state. Without this synchronous read Safari can coalesce both class
         changes into one paint and make the first Astrobear doors jump open. */
      if (!section.classList.contains('ak-home-preexpanded')) {
        void imageCover.offsetHeight;
      }


      imageCover.classList.remove(
        'ak-carousel-cover-closed'
      );


      imageCover.classList.add(
        'ak-carousel-cover-opening'
      );


      section._akInitialCoverFinishTimer =
        setTimeout(
          function () {

          section._akInitialCoverFinishTimer =
            null;

          imageCover.classList.remove(
            'ak-carousel-cover-opening'
          );


          section.classList.remove(
            'ak-later-initial-cover-opening'
          );


          /* Only the very first Astrobear reveal uses the asymmetric
             homepage doors. Once that reveal has finished, restore the
             standard centred 50/50 doors and their artwork for every
             later Prev/Next transition. */
          if (
            section.classList.contains(
              'ak-home-first-featured'
            )
          ) {

            section.classList.add(
              'ak-home-first-door-normalized'
            );


            imageCover.classList.add(
              'ak-desktop-door-image-visible'
            );

          }


          var currentPath =
            window.location.pathname
              .replace(
                /\/+$/,
                ''
              )
              .toLowerCase();


          if (
            window.AK_FEATURED_VISIT
          ) {

            if (
              (
                currentPath ===
                '' ||
                currentPath ===
                '/'
              ) &&
              section.classList.contains(
                'ak-home-featured-candidate'
              )
            ) {

              window.AK_FEATURED_VISIT
                .markHomePlayed();

            }


            if (
              currentPath ===
                '/collections/papers-front' &&
              section.classList.contains(
                'ak-papers-front-first-carousel'
              )
            ) {

              window.AK_FEATURED_VISIT
                .markPapersPlayed();

            }


            if (
              document.querySelector(
                'section.ak-featured-carousel'
              ) === section
            ) {

              window.AK_FEATURED_VISIT
                .markCurrentPagePlayed();

            }

          }

        },
          section.classList.contains('ak-home-first-featured')
            ? 1000
            : section.classList.contains('ak-later-initial-cover-opening')
              ? 510
              : 510
        );

    }


    var hasReleased =
      false;


    function releaseDesktopCover() {

      if (
        hasReleased
      ) {
        return;
      }


      hasReleased =
        true;

      /* Carousel 02+ starts at the shared 65% viewport gate. Commit its
         closed artwork before opening, without another timed hold. */
      if (document.body.classList.contains('ak-papers-editorial-page') ||
          (!section.classList.contains('ak-home-first-featured') &&
           !section.classList.contains('ak-papers-front-first-carousel'))) {
        section.classList.add('ak-desktop-cover-ready', 'ak-desktop-image-ready');
        if (section.classList.contains('ak-papers-front-preexpanded')) {
          section.classList.add('ak-papers-front-preexpanded-visible');
        }
        imageCover.classList.add('ak-desktop-door-image-visible');
        if (!section.classList.contains('ak-home-preexpanded')) {
          void imageCover.offsetHeight;
        }

        section.classList.add('ak-later-initial-cover-opening');
        openCover();

        return;
      }


      /*
        PAPERS FRONT
        CAROUSEL 02+

        FADE COMPLETE CAROUSEL IN
        IMMEDIATELY.

        OPEN EXISTING DOORS
        0.61 SECONDS LATER.
      */

      if (
        section.classList.contains(
          'ak-papers-front-preexpanded'
        )
      ) {

        section.classList.add(
          'ak-desktop-cover-ready',
          'ak-desktop-image-ready',
          'ak-papers-front-preexpanded-visible'
        );


        imageCover.classList.add(
          'ak-desktop-door-image-visible'
        );


        setTimeout(
          function () {

            openCover();

          },
          610
        );


        return;

      }


      /*
        EVERYTHING ELSE

        KEEP EXISTING TIMING
        EXACTLY AS BEFORE.
      */

      section.classList.add(
        'ak-desktop-cover-ready'
      );


      imageCover.classList.add(
        'ak-desktop-door-image-visible'
      );


      setTimeout(
        function () {

          section.classList.add(
            'ak-desktop-image-ready'
          );


          setTimeout(
            function () {

              openCover();

            },
            650
          );

        },
        250
      );

    }


    // Preexpanded homepage tracks have their final geometry before scrolling.
    // Release existing closed doors without a synchronous style/layout flush.
    if (section.classList.contains('ak-home-preexpanded') &&
        !section.classList.contains('ak-home-first-featured')) {
      releaseDesktopCover();
      return;
    }

    var desktopCarouselWidth =
      document.body.classList.contains(
        'ak-site-frame-enabled'
      )
        ? section.getBoundingClientRect().width
        : window.innerWidth;


    var desktopInfoHeight = parseFloat(
      getComputedStyle(section).getPropertyValue('--ak-carousel-info-height')
    ) || 80;

    var desktopTargetTrackHeight =
      section.classList.contains(
        'ak-featured-carousel--square'
      )
        ? (
            desktopCarouselWidth *
            0.25
          ) +
          desktopInfoHeight
        : (
            desktopCarouselWidth *
            5 /
            16
          ) +
          desktopInfoHeight;


    var desktopTrackHeightObserver =
      new ResizeObserver(
        function (
          entries
        ) {

          if (
            hasReleased
          ) {

            desktopTrackHeightObserver.disconnect();

            return;

          }


          var entry =
            entries[0];


          if (
            !entry
          ) {
            return;
          }


          var currentTrackHeight =
            entry.contentRect.height;


          if (
            currentTrackHeight >=
            desktopTargetTrackHeight *
            0.99
          ) {

            desktopTrackHeightObserver.disconnect();


            releaseDesktopCover();

          }

        }
      );


    desktopTrackHeightObserver.observe(
      track
    );


    setTimeout(
      function () {

        releaseDesktopCover();

      },
      3100
    );

  }


  /* =====================================================
     PAPERS FRONT
  ===================================================== */

  function isAkPapersFrontPage() {

    var path =
      window.location.pathname.replace(
        /\/+$/,
        ''
      );


    return (
      path ===
      '/collections/papers-front'
    );

  }


  /* =====================================================
     BIND ONE CAROUSEL REVEAL
  ===================================================== */

  function bindAkCarouselReveal(
    section,
    firstMobileCarousel,
    isMobile
  ) {

    if (
      !section ||
      section.dataset.akImageRevealBound ===
      'true'
    ) {
      return;
    }


    section.dataset.akImageRevealBound =
      'true';


    var revealTimer =
      null;


    if (
      !isMobile
    ) {

      var imageCover =
        section.querySelector(
          '.ak-carousel-image-cover'
        );


      if (
        imageCover
      ) {

        imageCover.classList.remove(
          'ak-carousel-cover-closing',
          'ak-carousel-cover-opening'
        );


        imageCover.classList.add(
          'ak-carousel-cover-closed'
        );

      }

    }


    var observer =
      new IntersectionObserver(
        function (
          entries
        ) {

          entries.forEach(
            function (
              entry
            ) {

              if (
                !entry.isIntersecting
              ) {

                if (
                  revealTimer
                ) {

                  clearTimeout(
                    revealTimer
                  );


                  revealTimer =
                    null;

                }


                return;

              }


              if (
                revealTimer
              ) {
                return;
              }


              var revealDelay =
                (
                  isMobile &&
                  section ===
                  firstMobileCarousel
                )
                  ? 900
                  : 200;


              revealTimer =
                setTimeout(
                  function () {

                    var rect =
                      section.getBoundingClientRect();


                    var viewportHeight =
                      window.innerHeight ||
                      document.documentElement.clientHeight;


                    var stillVisible =
                      rect.bottom >
                      0 &&
                      rect.top <
                      viewportHeight;


                    if (
                      !stillVisible
                    ) {

                      revealTimer =
                        null;


                      return;

                    }


                    if (
                      !isMobile &&
                      section.dataset.akDesktopCenterStopEligible !==
                        'true'
                    ) {

                      openAkDesktopInitialCover(
                        section
                      );

                    }


                    section.classList.add(
                      'ak-section-visible'
                    );


                    var isPreexpandedMobileCarousel =
                      isMobile &&
                      section.classList.contains(
                        'ak-mobile-preexpanded-cross'
                      );


                    var isFirstPapersDesktopCarousel =
                      !isMobile &&
                      isAkPapersFrontPage() &&
                      section.classList.contains(
                        'ak-papers-front-first-carousel'
                      );


                    if (
                      !isPreexpandedMobileCarousel
                    ) {

                      if (
                        isFirstPapersDesktopCarousel
                      ) {

                        /*
                          KEEP THE COMPLETE
                          CAROUSEL TOP VISIBLE
                          FOR 0.3 SECONDS
                          BEFORE EXPANSION STARTS.
                        */

                        setTimeout(
                          function () {

                            section.classList.add(
                              'ak-images-visible'
                            );

                          },
                          900
                        );

                      } else {

                        section.classList.add(
                          'ak-images-visible'
                        );

                      }

                    }


                    observer.unobserve(
                      section
                    );


                    revealTimer =
                      null;

                  },
                  revealDelay
                );

            }
          );

        },
        {
          threshold:
            isMobile
              ? 0.10
              : 0.25,

          rootMargin:
            isMobile
              ? '0px 0px -2% 0px'
              : '0px 0px -8% 0px'
        }
      );


    observer.observe(
      section
    );

  }

  /* =====================================================
     DESKTOP CAROUSEL CENTER STOP

     CAROUSEL 01:
     NEVER USES THIS SYSTEM.

     CAROUSEL 02+:
     ↓
     CENTER REACHES 50% VIEWPORT
     ↓
     SNAP EXACTLY TO CENTER
     ↓
     TEMPORARILY LOCK PAGE
     ↓
     OPEN EXISTING DOORS
     ↓
     RELEASE PAGE WHEN DOORS
     HAVE FINISHED OPENING
  ===================================================== */

  var akDesktopCarouselCenterStopActive =
    null;


  var akDesktopCarouselCenterStopScrollY =
    0;


  function lockAkDesktopCarouselScroll(
    section
  ) {

    if (
      !section ||
      akDesktopCarouselCenterStopActive
    ) {
      return;
    }


    akDesktopCarouselCenterStopActive =
      section;


    akDesktopCarouselCenterStopScrollY =
      window.scrollY;


    document.documentElement.style.setProperty(
      'overflow',
      'hidden',
      'important'
    );


    document.body.style.setProperty(
      'position',
      'fixed',
      'important'
    );


    document.body.style.setProperty(
      'top',
      (
        akDesktopCarouselCenterStopScrollY *
        -1
      ) +
      'px',
      'important'
    );


    document.body.style.setProperty(
      'left',
      '0',
      'important'
    );


    document.body.style.setProperty(
      'right',
      '0',
      'important'
    );


    document.body.style.setProperty(
      'width',
      '100%',
      'important'
    );


    document.body.style.setProperty(
      'overflow',
      'hidden',
      'important'
    );

  }


  function unlockAkDesktopCarouselScroll(
    section
  ) {

    if (
      !section ||
      akDesktopCarouselCenterStopActive !==
        section
    ) {
      return;
    }


    var restoreY =
      akDesktopCarouselCenterStopScrollY;


    document.documentElement.style.removeProperty(
      'overflow'
    );


    document.body.style.removeProperty(
      'position'
    );


    document.body.style.removeProperty(
      'top'
    );


    document.body.style.removeProperty(
      'left'
    );


    document.body.style.removeProperty(
      'right'
    );


    document.body.style.removeProperty(
      'width'
    );


    document.body.style.removeProperty(
      'overflow'
    );


    akDesktopCarouselCenterStopActive =
      null;


    window.scrollTo(
      0,
      restoreY
    );

  }


  /* =====================================================
     EXACTLY CENTER ONE CAROUSEL
  ===================================================== */

  function centerAkDesktopCarouselSmooth(
    section,
    callback
  ) {

    if (
      !section
    ) {
      return;
    }


    var rect =
      section.getBoundingClientRect();


    var carouselCenter =
      rect.top +
      (
        rect.height /
        2
      );


    var viewportCenter =
      window.innerHeight /
      2;


    var startY =
      window.scrollY;


    var correction =
      carouselCenter -
      viewportCenter;


    var targetY =
      startY +
      correction;


    /*
      VERY SMALL CORRECTION.

      NO NEED TO ANIMATE.
    */

    if (
      Math.abs(
        correction
      ) <=
      0.5
    ) {

      window.scrollTo(
        0,
        targetY
      );


      if (
        typeof callback ===
        'function'
      ) {

        callback();

      }


      return;

    }


    /*
      SMOOTH FINAL APPROACH
      TO EXACT VIEWPORT CENTER.
    */

    var duration =
      220;


    var startTime =
      performance.now();


    function frame(
      now
    ) {

      var elapsed =
        now -
        startTime;


      var progress =
        Math.min(
          1,
          elapsed /
          duration
        );


      /*
        SMOOTH EASE OUT.

        FAST ENOUGH TO FEEL
        CONNECTED TO SCROLL,
        BUT NO HARD SNAP.
      */

      var eased =
        1 -
        Math.pow(
          1 -
          progress,
          3
        );


      var currentY =
        startY +
        (
          targetY -
          startY
        ) *
        eased;


      window.scrollTo(
        0,
        currentY
      );


      if (
        progress <
        1
      ) {

        requestAnimationFrame(
          frame
        );


        return;

      }


      /*
        FORCE EXACT FINAL PIXEL.
      */

      window.scrollTo(
        0,
        targetY
      );


      if (
        typeof callback ===
        'function'
      ) {

        callback();

      }

    }


    requestAnimationFrame(
      frame
    );

  }


  /* =====================================================
     WAIT FOR EXISTING DOORS TO
     OPEN AND THEN RELEASE SCROLL
  ===================================================== */

  function waitForAkDesktopCarouselDoors(
    section
  ) {

    if (
      !section
    ) {
      return;
    }


    var imageCover =
      section.querySelector(
        '.ak-carousel-image-cover'
      );


    if (
      !imageCover
    ) {

      unlockAkDesktopCarouselScroll(
        section
      );


      return;
    }


    var released =
      false;


    function release() {

      if (
        released
      ) {
        return;
      }


      released =
        true;


      if (
        observer
      ) {

        observer.disconnect();

      }


      section.dataset.akDesktopCenterStopComplete =
        'true';


      if (
        section.classList.contains(
          'ak-home-first-featured'
        )
      ) {

        section.classList.add(
          'ak-home-first-door-normalized'
        );


        imageCover.classList.add(
          'ak-desktop-door-image-visible'
        );

      }


      unlockAkDesktopCarouselScroll(
        section
      );

    }


    var observer =
      new MutationObserver(
        function () {

          /*
            EXISTING CAROUSEL CODE
            REMOVES THIS CLASS WHEN
            THE DOOR OPENING HAS
            FINISHED.
          */

          if (
            imageCover.classList.contains(
              'ak-carousel-cover-opening'
            )
          ) {

            section.dataset.akDesktopCenterDoorsStarted =
              'true';


            return;
          }


          if (
            section.dataset.akDesktopCenterDoorsStarted ===
              'true' &&
            !imageCover.classList.contains(
              'ak-carousel-cover-opening'
            )
          ) {

            release();

          }

        }
      );


    observer.observe(
      imageCover,
      {
        attributes:
          true,

        attributeFilter:
          [
            'class'
          ]
      }
    );


    /*
      SAFETY ONLY.

      NEVER LEAVE PAGE LOCKED
      IF SOMETHING EXTERNAL
      INTERRUPTS THE DOOR SEQUENCE.
    */

    setTimeout(
      function () {

        release();

      },
      4500
    );

  }


  /* =====================================================
     START ONE CENTER REVEAL

     IMPORTANT:

     50% VIEWPORT ONLY TRIGGERS
     THE EXISTING DOOR OPENING.

     NO CENTER SNAP.
     NO PAGE LOCK.
     NO FORCED SCROLL POSITION.
  ===================================================== */

  function startAkDesktopCarouselCenterStop(
    section
  ) {

    if (
      !section ||
      section.dataset.akDesktopCenterStopStarted ===
        'true' ||
      section.dataset.akDesktopCenterStopComplete ===
        'true'
    ) {
      return;
    }


    section.dataset.akDesktopCenterStopStarted =
      'true';


    openAkDesktopInitialCover(
      section
    );


    section.dataset.akDesktopCenterStopComplete =
      'true';

  }


  /* =====================================================
     CHECK CENTER CROSSING
  ===================================================== */

  function checkAkDesktopCarouselCenterStops() {

    if (
      !window.matchMedia(
        '(min-width: 1201px)'
      ).matches
    ) {
      return;
    }


    if (
      akDesktopCarouselCenterStopActive
    ) {
      return;
    }


    document
      .querySelectorAll(
        'section.ak-featured-carousel'
      )
      .forEach(
        function (
          section,
          index
        ) {

          /*
            =================================================
            CAROUSEL 01

            NEVER STOP.

            IT RETAINS ITS EXISTING
            AUTOMATIC OPENING.
            =================================================
          */

          if (
            index ===
            0
          ) {
            return;
          }


          if (
            section.dataset.akDesktopCenterStopEligible !==
              'true' ||
            section.dataset.akDesktopCenterStopStarted ===
              'true' ||
            section.dataset.akDesktopCenterStopComplete ===
              'true'
          ) {
            return;
          }


          var rect =
            section.getBoundingClientRect();


          if (
            rect.height <=
            0
          ) {
            return;
          }


          var carouselCenter =
            rect.top +
            (
              rect.height /
              2
            );


          var triggerPoint =
            window.innerHeight *
            0.65;


          /*
            CAROUSEL 02+

            OPEN DOORS WHEN
            CAROUSEL CENTER REACHES
            65% OF VIEWPORT.

            CAROUSEL 01 IS NOT
            PART OF THIS SYSTEM.
          */

          if (
            carouselCenter >
              triggerPoint
          ) {
            return;
          }


          startAkDesktopCarouselCenterStop(
            section
          );

        }
      );

  }


  /* =====================================================
     BIND DESKTOP CENTER STOP
  ===================================================== */

  var akDesktopCarouselCenterStopBound =
    false;


  function bindAkDesktopCarouselCenterStops() {

    if (
      akDesktopCarouselCenterStopBound
    ) {
      return;
    }


    akDesktopCarouselCenterStopBound =
      true;


    var sections =
      document.querySelectorAll(
        'section.ak-featured-carousel[data-ak-desktop-center-stop-eligible="true"]'
      );


    if (
      !(
        'IntersectionObserver' in
        window
      )
    ) {

      sections.forEach(
        startAkDesktopCarouselCenterStop
      );


      return;

    }


    /* Browser-managed, one-shot observation replaces the old global scroll
       handler. The lower 18% of the viewport is excluded, matching the
       established 82vh reveal zone without measuring every carousel on
       every scroll frame. */
    var observer =
      new IntersectionObserver(
        function (
          entries
        ) {

          entries.forEach(
            function (
              entry
            ) {

              if (
                !entry.isIntersecting
              ) {
                return;
              }


              startAkDesktopCarouselCenterStop(
                entry.target
              );


              observer.unobserve(
                entry.target
              );

            }
          );

        },
        {
          root:
            null,

          rootMargin:
            '0px 0px -18% 0px',

          threshold:
            0.01
        }
      );


    sections.forEach(
      function (
        section
      ) {

        observer.observe(
          section
        );

      }
    );

  }

  /* =====================================================
     INIT IMAGE REVEAL
  ===================================================== */

  function initAkImageReveal() {
    if(document.documentElement.classList.contains('ak-carousel-page-revisit')) {
      document.querySelectorAll('section.ak-featured-carousel').forEach(window.akCommitCarouselRevisit);
      return;
    }

    if (
      window.matchMedia(
        '(max-width: 1200px)'
      ).matches
    ) {
      return;
    }

    var sections =
      Array.from(
        document.querySelectorAll(
          'section.ak-featured-carousel'
        )
      );


    if (
      !sections.length
    ) {
      return;
    }

    /* ===================================================
       DESKTOP CENTER STOP ROLES

       01:
       EXISTING AUTOMATIC OPEN.

       02+:
       OPEN ONLY AT EXACT
       VIEWPORT CENTER.
    =================================================== */

    sections.forEach(
      function (
        section,
        index
      ) {

        if (
          index ===
          0
        ) {

          section.dataset.akDesktopCenterStopEligible =
            'false';


          return;

        }


        section.dataset.akDesktopCenterStopEligible =
          'true';

      }
    );


    bindAkDesktopCarouselCenterStops();


    var currentPath =
      window.location.pathname
        .replace(
          /\/+$/,
          ''
        )
        .toLowerCase();


    var isHomePage =
      (
        currentPath ===
        ''
      ) ||
      (
        currentPath ===
        '/'
      );


    var isPapersFrontPage =
      (
        currentPath ===
        '/collections/papers-front'
      );


    /* ===================================================
       ALREADY PLAYED THIS VISIT
       OPEN IMMEDIATELY — NO INTRO
    =================================================== */


    if (
      isHomePage &&
      window.AK_FEATURED_VISIT &&
      window.AK_FEATURED_VISIT.homeAlreadyPlayed
    ) {

      sections.forEach(
        function (
          section,
          index
        ) {

          if (
            index ===
              0
          ) {

            section.classList.add(
              'ak-home-first-featured',
              'ak-astrobear-breathing-ready',
              'ak-home-first-door-normalized'
            );

          }


          if (index === 0 && window.matchMedia('(max-width: 1200px)').matches) {
            document.documentElement.classList.remove('ak-home-featured-already-played');
            return;
          }

          section.classList.add(
            'ak-section-visible',
            'ak-images-visible',
            'ak-desktop-cover-ready',
            'ak-desktop-image-ready',
            'ak-view-collection-ready',
            'ak-mobile-cross-finished',
            'ak-mobile-cross-image-ready',
            'ak-mobile-slide-hint-ready',
            'ak-mobile-reveal-complete'
          );


          section.dataset.akInitialCoverOpened =
            'true';


          section.dataset.akImageRevealBound =
            'true';


          var imageCover =
            section.querySelector(
              '.ak-carousel-image-cover'
            );


          if (
            imageCover
          ) {

            imageCover.classList.remove(
              'ak-carousel-cover-closing',
              'ak-carousel-cover-closed',
              'ak-carousel-cover-opening'
            );


            imageCover.classList.add(
              'ak-desktop-door-image-visible'
            );

          }

        }
      );


      return;

    }


    if (
      isPapersFrontPage &&
      (!document.body.classList.contains('ak-papers-editorial-page') || window.innerWidth <= 1200) &&
      window.AK_FEATURED_VISIT &&
      window.AK_FEATURED_VISIT.papersAlreadyPlayed
    ) {

      sections.forEach(
        function (
          section
        ) {

          section.classList.add(
            'ak-section-visible',
            'ak-images-visible',
            'ak-desktop-cover-ready',
            'ak-desktop-image-ready',
            'ak-view-collection-ready',
            'ak-mobile-cross-finished',
            'ak-mobile-cross-image-ready',
            'ak-mobile-reveal-complete'
          );


          section.dataset.akInitialCoverOpened =
            'true';


          var imageCover =
            section.querySelector(
              '.ak-carousel-image-cover'
            );


          if (
            imageCover
          ) {

            imageCover.classList.remove(
              'ak-carousel-cover-closing',
              'ak-carousel-cover-closed',
              'ak-carousel-cover-opening'
            );


            imageCover.classList.add(
              'ak-desktop-door-image-visible'
            );

          }

        }
      );


      return;

    }


    if (
      !isHomePage &&
      !isPapersFrontPage &&
      window.AK_FEATURED_VISIT &&
      window.AK_FEATURED_VISIT.currentPageAlreadyPlayed
    ) {

      sections.forEach(
        function (
          section
        ) {

          section.classList.add(
            'ak-section-visible',
            'ak-images-visible',
            'ak-desktop-cover-ready',
            'ak-desktop-image-ready',
            'ak-view-collection-ready',
            'ak-mobile-cross-finished',
            'ak-mobile-cross-image-ready',
            'ak-mobile-slide-hint-ready',
            'ak-mobile-reveal-complete'
          );


          section.dataset.akInitialCoverOpened =
            'true';


          section.dataset.akImageRevealBound =
            'true';


          var imageCover =
            section.querySelector(
              '.ak-carousel-image-cover'
            );


          if (
            imageCover
          ) {

            imageCover.classList.remove(
              'ak-carousel-cover-closing',
              'ak-carousel-cover-closed',
              'ak-carousel-cover-opening'
            );


            imageCover.classList.add(
              'ak-desktop-door-image-visible'
            );

          }

        }
      );


      return;

    }


    var firstMobileCarousel =
      sections[0];


    var isMobile =
      window.matchMedia(
        '(max-width: 1200px)'
      ).matches;


    var isPapersFront =
      isAkPapersFrontPage();


    /* ===================================================
       NORMAL BEHAVIOUR

       EVERY OTHER PAGE STAYS EXACTLY AS BEFORE
    =================================================== */

    if (
      isHomePage
    ) {

      sections.forEach(
        function (
          section
        ) {

          bindAkCarouselReveal(
            section,
            firstMobileCarousel,
            isMobile
          );

        }
      );


      return;

    }


    if (
      isPapersFront
    ) {

      sections.forEach(
        function (
          section
        ) {

          bindAkCarouselReveal(
            section,
            firstMobileCarousel,
            isMobile
          );

        }
      );


      return;

    }


    sections.forEach(
      function (
        section
      ) {

        bindAkCarouselReveal(
          section,
          firstMobileCarousel,
          isMobile
        );

      }
    );


    /* ===================================================
       PAPERS FRONT — DESKTOP

       ALL CAROUSELS GET THEIR OWN VIEWPORT OBSERVER
       IMMEDIATELY.

       CAROUSEL 1:
       - STARTS COLLAPSED
       - EXPANDS WHEN IT ENTERS VIEWPORT

       CAROUSEL 2+:
       - START PRE-EXPANDED FROM CSS
       - DO NOT RUN HEIGHT EXPANSION

       ALL CAROUSELS:
       - DOORS / IMAGE / NAV ANIMATIONS
         STILL START INDIVIDUALLY WHEN
         EACH CAROUSEL ENTERS VIEWPORT.
    =================================================== */

    sections.forEach(
      function (
        section
      ) {

        bindAkCarouselReveal(
          section,
          firstMobileCarousel,
          false
        );

      }
    );

  }


  /* =====================================================
     INIT
     WAIT FOR GLOBAL BOOT REVEAL
  ===================================================== */

  function startAkImageRevealAfterBoot() {

    if (
      window.innerWidth >
      1200
    ) {

      if (
        typeof window.whenAkRevealed ===
        'function'
      ) {

        window.whenAkRevealed(
          function () {

            requestAnimationFrame(
              function () {

                requestAnimationFrame(
                  function () {

                    initAkImageReveal();

                  }
                );

              }
            );

          }
        );


        return;

      }

    }


    initAkImageReveal();

  }


  /* =====================================================
     FAST NATIVE SCROLL RECOVERY

     Safari can move a section from below to above the viewport between two
     IntersectionObserver deliveries.  In that case the one-shot reveal is
     never allowed to commit and the carousel is left as an empty frame.  A
     small passive verifier therefore commits the normal final state only
     when a section has actually been skipped, or when one fast gesture has
     carried it into the viewport.  It never changes scroll position and it
     does not run the normal, slow-scroll animation early.
  ===================================================== */

  function commitAkFeaturedCarouselStableState(
    section
  ) {

    if (section && window.innerWidth > 1200 &&
        document.body.classList.contains('ak-papers-editorial-page') &&
        !section.classList.contains('ak-paper-cta-ready')) return;

    if (
      !section ||
      section.dataset.akFastScrollSettled ===
        'true'
    ) {
      return;
    }


    /* The homepage intro owns carousel 01 until it has physically landed.
       Settling it before that point would race the door/scroll-lock handoff. */
    if (
      section.classList.contains(
        'ak-home-first-featured'
      ) &&
      !section.classList.contains(
        'ak-home-stage-landed'
      )
    ) {
      return;
    }


    section.dataset.akFastScrollSettled =
      'true';


    section.dataset.akInitialCoverOpened =
      'true';


    section.dataset.akDesktopCenterStopStarted =
      'true';


    section.dataset.akDesktopCenterStopComplete =
      'true';


    if (
      section._akInitialCoverFinishTimer
    ) {
      window.clearTimeout(
        section._akInitialCoverFinishTimer
      );
    }


    if (
      section._akInitialCoverOpenDelayTimer
    ) {
      window.clearTimeout(
        section._akInitialCoverOpenDelayTimer
      );
    }


    if (
      typeof window.akReleaseDeferredCarouselImages ===
        'function'
    ) {
      window.akReleaseDeferredCarouselImages(
        section
      );
    }


    if (
      typeof window.akObserveDeferredCarouselImages ===
        'function'
    ) {
      window.akObserveDeferredCarouselImages(
        section
      );
    }


    section.classList.remove(
      'ak-home-stage-hold',
      'ak-home-doors-held',
      'ak-later-initial-cover-opening'
    );


    section.classList.add(
      'ak-section-visible',
      'ak-images-visible',
      'ak-desktop-cover-ready',
      'ak-desktop-image-ready',
      'ak-view-collection-ready',
      'ak-mobile-cross-finished',
      'ak-mobile-cross-image-ready',
      'ak-mobile-slide-hint-ready',
      'ak-mobile-reveal-complete'
    );


    var imageCover =
      section.querySelector(
        '.ak-carousel-image-cover'
      );


    if (
      imageCover
    ) {
      imageCover.classList.remove(
        'ak-carousel-cover-closing',
        'ak-carousel-cover-closed',
        'ak-carousel-cover-opening'
      );


      imageCover.classList.add(
        'ak-desktop-door-image-visible'
      );
    }


    /* A fast gesture may skip the normal transitionend path and commit this
       exact open state directly.  Persist that result as well, otherwise a
       reload in the same tab would incorrectly rebuild closed doors. */
    if (
      document.querySelector(
        'section.ak-featured-carousel'
      ) === section &&
      window.AK_FEATURED_VISIT
    ) {

      var settledPath =
        window.location.pathname
          .replace(
            /\/+$/,
            ''
          )
          .toLowerCase();


      if (
        settledPath ===
          '' ||
        settledPath ===
          '/'
      ) {

        window.AK_FEATURED_VISIT
          .markHomePlayed();

      } else if (
        settledPath ===
          '/collections/papers-front'
      ) {

        window.AK_FEATURED_VISIT
          .markPapersPlayed();

      } else {

        window.AK_FEATURED_VISIT
          .markCurrentPagePlayed();

      }

    }

  }


  function bindAkFeaturedFastScrollRecovery() {

    if (
      window.__AK_FEATURED_FAST_SCROLL_RECOVERY_BOUND__
    ) {
      return;
    }


    window.__AK_FEATURED_FAST_SCROLL_RECOVERY_BOUND__ =
      true;

    if (window.matchMedia('(min-width: 1201px)').matches && 'IntersectionObserver' in window) {
      var firstCarousel = document.querySelector('section.ak-featured-carousel');
      // Recovery concerns sections already passed. Use the observer's cached
      // geometry, never force carousel layout on every desktop scroll frame.
      var recoveryObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var section = entry.target;
          if (entry.boundingClientRect.bottom > 0 ||
              section.dataset.akCoverRunning === 'true' ||
              section.dataset.akFastScrollSettled === 'true') return;
          if (section !== firstCarousel &&
              (section.dataset.akInitialCoverOpened !== 'true' ||
               section._akInitialCoverOpenDelayTimer ||
               section.querySelector('.ak-carousel-cover-opening'))) return;
          commitAkFeaturedCarouselStableState(section);
        });
      }, { threshold: 0 });
      document.querySelectorAll('section.ak-featured-carousel').forEach(function (section) {
        recoveryObserver.observe(section);
      });
      return;
    }

    var lastY =
      window.scrollY || 0;


    var gestureDistance =
      0;


    var gestureStartedAt =
      performance.now();


    var framePending =
      false;


    function verifyAkFeaturedStates() {

      framePending =
        false;


      var now =
        performance.now();


      var currentY =
        window.scrollY || 0;


      if (
        now - gestureStartedAt >
          160
      ) {
        gestureStartedAt =
          now;


        gestureDistance =
          0;
      }


      gestureDistance +=
        Math.abs(
          currentY - lastY
        );


      lastY =
        currentY;


      var viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;


      var isFastGesture =
        gestureDistance >=
          viewportHeight * 0.42;


      document
        .querySelectorAll(
          'section.ak-featured-carousel'
        )
        .forEach(
          function (
            section
          ) {

            if (
              section.dataset.akCoverRunning === 'true' ||
              section.dataset.akFastScrollSettled ===
                'true'
            ) {
              return;
            }


            // Momentum recovery cannot bypass a later carousel's initial
            // centre gate or its closed/opening reading state.
            if (section !== document.querySelector('section.ak-featured-carousel') &&
                (section.dataset.akInitialCoverOpened !== 'true' ||
                 section._akInitialCoverOpenDelayTimer ||
                 section.querySelector('.ak-carousel-cover-opening'))) return;

            var rect =
              section.getBoundingClientRect();


            var wasSkipped =
              rect.bottom <= 0;


            var wasReachedFast =
              isFastGesture &&
              rect.top < viewportHeight &&
              rect.bottom > 0;


            if (
              wasSkipped ||
              wasReachedFast
            ) {
              commitAkFeaturedCarouselStableState(
                section
              );
            }

          }
        );

    }


    function scheduleAkFeaturedStateVerification() {

      if (
        framePending
      ) {
        return;
      }


      framePending =
        true;


      window.requestAnimationFrame(
        verifyAkFeaturedStates
      );

    }


    window.addEventListener(
      'scroll',
      scheduleAkFeaturedStateVerification,
      {
        passive:
          true
      }
    );


    window.addEventListener(
      'pageshow',
      scheduleAkFeaturedStateVerification
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startAkImageRevealAfterBoot
    );


    document.addEventListener(
      'DOMContentLoaded',
      bindAkFeaturedFastScrollRecovery
    );

  } else {

    startAkImageRevealAfterBoot();


    bindAkFeaturedFastScrollRecovery();

  }


  /* =====================================================
     SHOPIFY
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      requestAnimationFrame(
        function () {

          initAkImageReveal();

        }
      );

    }
  );

})();


(function () {

  function buildAkFeaturedHeaderGrid(
    grid,
    numberOfCells,
    cellClass
  ) {
    if (
      !grid ||
      grid.dataset.akFeaturedHeaderBuilt === 'true'
    ) {
      return;
    }

    grid.dataset.akFeaturedHeaderBuilt = 'true';

    var fragment =
      document.createDocumentFragment();

    for (var i = 0; i < numberOfCells; i++) {
      var cell =
        document.createElement('div');

      cell.className = cellClass;

      fragment.appendChild(cell);
    }

    grid.appendChild(fragment);
  }


  function initAkFeaturedHeaderGrid() {
    document
      .querySelectorAll(
        'section.ak-featured-carousel'
      )
      .forEach(function (section) {

        buildAkFeaturedHeaderGrid(
          section.querySelector(
            '.ak-slider-nav-structural-left'
          ),
          2,
          'ak-slider-nav-structural-cell'
        );

        buildAkFeaturedHeaderGrid(
          section.querySelector(
            '.ak-slider-nav-structural-center'
          ),
          96,
          'ak-slider-nav-structural-cell'
        );

        buildAkFeaturedHeaderGrid(
          section.querySelector(
            '.ak-slider-nav-structural-right'
          ),
          2,
          'ak-slider-nav-structural-cell'
        );


        var headerCenter =
          section.querySelectorAll(
            '.ak-featured-header-structural-center ' +
            '.ak-featured-header-structural-cell'
          );

        var sliderCenter =
          section.querySelectorAll(
            '.ak-slider-nav-structural-center ' +
            '.ak-slider-nav-structural-cell'
          );


        if (
          headerCenter.length === 96 &&
          sliderCenter.length === 96
        ) {

          section.classList.add(
            'is-ak-featured-grid-built'
          );

        }

      });
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAkFeaturedHeaderGrid
    );
  } else {
    initAkFeaturedHeaderGrid();
  }


  document.addEventListener(
    'shopify:section:load',
    initAkFeaturedHeaderGrid
  );

})();


(function () {
  var isFirefox =
    navigator.userAgent
      .toLowerCase()
      .indexOf('firefox') !== -1;

  var akFeaturedFirefoxResizeTimer;


  function syncAkFeaturedFirefoxPattern(
    section
  ) {
    if (
      !isFirefox ||
      !section ||
      window.innerWidth <= 1200
    ) {
      return;
    }

    var patternSlot =
      section.querySelector(
        '.ak-featured-header-pattern-slot'
      );

    var structuralCells =
      section.querySelectorAll(
        '.ak-featured-header-structural-center ' +
        '.ak-featured-header-structural-cell'
      );

    var firstCellOnRightHalf =
      structuralCells[48];

    if (
      !patternSlot ||
      !firstCellOnRightHalf
    ) {
      return;
    }

    var patternRect =
      patternSlot.getBoundingClientRect();

    var centerRect =
      firstCellOnRightHalf.getBoundingClientRect();

    var inset =
      centerRect.left -
      patternRect.left;

    patternSlot.style.setProperty(
      '--ak-featured-firefox-pattern-inset',
      Math.max(
        0,
        inset
      ) + 'px'
    );
  }


  function syncAllAkFeaturedFirefoxPatterns() {
    if (!isFirefox) {
      return;
    }

    document
      .querySelectorAll(
        'section.ak-featured-carousel'
      )
      .forEach(function (section) {
        syncAkFeaturedFirefoxPattern(
          section
        );
      });
  }


  function scheduleAkFeaturedFirefoxPatternSync() {
    if (!isFirefox) {
      return;
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        syncAllAkFeaturedFirefoxPatterns();
      });
    });
  }


  function handleAkFeaturedFirefoxResize() {
    if (!isFirefox) {
      return;
    }

    clearTimeout(
      akFeaturedFirefoxResizeTimer
    );

    akFeaturedFirefoxResizeTimer =
      setTimeout(function () {
        scheduleAkFeaturedFirefoxPatternSync();
      }, 50);
  }


  function initAkFeaturedFirefoxPattern() {
    scheduleAkFeaturedFirefoxPatternSync();
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAkFeaturedFirefoxPattern
    );
  } else {
    initAkFeaturedFirefoxPattern();
  }


  window.addEventListener(
    'resize',
    handleAkFeaturedFirefoxResize
  );


  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(
        scheduleAkFeaturedFirefoxPatternSync,
        50
      );
    }
  );


  setTimeout(
    scheduleAkFeaturedFirefoxPatternSync,
    300
  );

  setTimeout(
    scheduleAkFeaturedFirefoxPatternSync,
    100
  );
})();


(function () {

  if (
    window.__AK_FEATURED_NAV_SYNC_INITIALIZED__
  ) {
    return;
  }


  window.__AK_FEATURED_NAV_SYNC_INITIALIZED__ =
    true;


  function getVisibleAkElement(
    selector
  ) {

    var elements =
      Array.from(
        document.querySelectorAll(
          selector
        )
      );

    return elements.find(
      function(element) {

        var rect =
          element.getBoundingClientRect();

        var styles =
          window.getComputedStyle(
            element
          );

        return (
          rect.width > 0 &&
          rect.height > 0 &&
          styles.display !== 'none' &&
          styles.visibility !== 'hidden'
        );

      }
    ) || null;

  }


  function startAkFeaturedViewAnimation(
    section
  ) {

    if (
      !section ||
      section.dataset.akViewCollectionAnimated ===
        'true'
    ) {
      return;
    }

    if (
      !section.classList.contains(
        'ak-images-visible'
      )
    ) {
      return;
    }

    var header =
      section.querySelector(
        '.ak-featured-header'
      );

    if (
      !header
    ) {
      return;
    }


    /*
      MOBILE

      MOBILE BOTTOM HEADER
      IS CONTROLLED ONLY BY
      THE MOBILE CAROUSEL LIQUID.
    */

    if (
      window.matchMedia(
        '(max-width: 1200px)'
      ).matches
    ) {

      return;

    }


    /*
      DESKTOP

      Keep the existing measured geometry from the
      locked bottom navigation.
    */

    var textWidth =
      parseFloat(
        header.style.getPropertyValue(
          '--ak-featured-link-text-width'
        )
      );

    var arrowWidth =
      parseFloat(
        header.style.getPropertyValue(
          '--ak-featured-link-arrow-width'
        )
      );

    if (
      !Number.isFinite(
        textWidth
      ) ||
      !Number.isFinite(
        arrowWidth
      ) ||
      textWidth <= 0 ||
      arrowWidth <= 0
    ) {
      return;
    }

    section.dataset.akViewCollectionAnimated =
      'true';

    section.classList.remove(
      'ak-view-collection-ready'
    );

    requestAnimationFrame(
      function() {

        requestAnimationFrame(
          function() {

            section.classList.add(
              'ak-view-collection-ready'
            );

          }
        );

      }
    );

  }


  function hasAkFeaturedHeaderGeometry(
    section
  ) {

    if (
      !section
    ) {
      return false;
    }


    var header =
      section.querySelector(
        '.ak-featured-header'
      );


    if (
      !header
    ) {
      return false;
    }


    var textWidth =
      parseFloat(
        header.style.getPropertyValue(
          '--ak-featured-link-text-width'
        )
      );

    var arrowWidth =
      parseFloat(
        header.style.getPropertyValue(
          '--ak-featured-link-arrow-width'
        )
      );


    return (
      Number.isFinite(
        textWidth
      ) &&
      Number.isFinite(
        arrowWidth
      ) &&
      textWidth > 0 &&
      arrowWidth > 0
    );

  }


  function startAkFeaturedMobileAnimations() {

    return;

  }


  function syncAkFeaturedHeaderToNav() {

    /*
      MOBILE

      MOBILE IS CONTROLLED ONLY
      BY THE MOBILE CAROUSEL LIQUID.

      THIS DESKTOP CONTROLLER
      MUST NOT TOUCH MOBILE.
    */

    if (
      !window.matchMedia(
        '(min-width: 1201px)'
      ).matches
    ) {

      return;

    }


    var logo =
      getVisibleAkElement(
        '.ak-bottom-logo-box'
      );

    var hatch =
      getVisibleAkElement(
        '.ak-hatch-box'
      );

    var cart =
      getVisibleAkElement(
        '.ak-bottom-cart-box'
      );


    if (
      !logo ||
      !hatch ||
      !cart
    ) {
      return;
    }


    /*
      READ NAV GEOMETRY ONCE
    */

    var logoRect =
      logo.getBoundingClientRect();

    var hatchRect =
      hatch.getBoundingClientRect();

    var cartRect =
      cart.getBoundingClientRect();


    var firstFeaturedCarousel =
      document.querySelector(
        'section.ak-featured-carousel'
      );


    document
      .querySelectorAll(
        'section.ak-featured-carousel'
      )
      .forEach(
        function(section) {

          /*
            Do not force geometry for every off-screen homepage carousel
            during the film sequence. Each later carousel is measured when
            its own reveal begins; the first one stays pre-measured so its
            header transition can start immediately after the film.
          */

          if (
            section !==
              firstFeaturedCarousel &&
            !section.classList.contains(
              'ak-images-visible'
            )
          ) {
            return;
          }

          var header =
            section.querySelector(
              '.ak-featured-header'
            );

          if (
            !header
          ) {
            return;
          }


          var track =
            section.querySelector(
              '.splide__track'
            );

          var titleCell =
            section.querySelector(
              '.ak-featured-header-title'
            );

          var spacerCell =
            section.querySelector(
              '.ak-featured-header-spacer'
            );

          var patternCell =
            section.querySelector(
              '.ak-featured-header-pattern-slot'
            );


          /*
            =====================================================
            READ PHASE

            ALL GEOMETRY IS READ BEFORE ANY CSS
            CUSTOM PROPERTIES ARE WRITTEN.
            =====================================================
          */

          var headerRect =
            header.getBoundingClientRect();


          var trackRect =
            track
              ? track.getBoundingClientRect()
              : null;

          var titleRect =
            titleCell
              ? titleCell.getBoundingClientRect()
              : null;

          var spacerRect =
            spacerCell
              ? spacerCell.getBoundingClientRect()
              : null;

          var patternRect =
            patternCell
              ? patternCell.getBoundingClientRect()
              : null;


          var carouselLine1 =
            0;

          var carouselLine2 =
            0;

          var carouselLine3 =
            0;


          if (
            trackRect &&
            titleRect &&
            spacerRect &&
            patternRect
          ) {

            carouselLine1 =
              titleRect.right -
              trackRect.left;

            carouselLine2 =
              spacerRect.right -
              trackRect.left;

            carouselLine3 =
              patternRect.right -
              trackRect.left;

          }


          var line1 =
            logoRect.right -
            headerRect.left;

          var line2 =
            hatchRect.right -
            headerRect.left;

          var line3 =
            cartRect.left -
            headerRect.left;

          var line4 =
            cartRect.right -
            headerRect.left;


          var dividerLine =
            line4 -
            1;


          var headerWidth =
            headerRect.width;


          var col1 =
            line1;

          var col2 =
            line2 -
            line1;

          var col3 =
            line3 -
            line2;

          var col4 =
            headerWidth -
            line3;


          var linkTextWidth =
            dividerLine -
            line3;

          var linkArrowWidth =
            headerWidth -
            dividerLine;


          if (
            linkTextWidth <= 0 ||
            linkArrowWidth <= 0
          ) {
            return;
          }


          var titleFullWidth =
            col1;


          var titleTextWidth =
            titleFullWidth -
            linkArrowWidth;


          if (
            titleFullWidth <= 0 ||
            titleTextWidth <= 0
          ) {
            return;
          }


          /*
            =====================================================
            WRITE PHASE

            NO MORE GEOMETRY READS BELOW THIS POINT.
            =====================================================
          */

          if (
            trackRect &&
            titleRect &&
            spacerRect &&
            patternRect
          ) {

            section.style.setProperty(
              '--ak-carousel-line-1',
              carouselLine1 + 'px'
            );

            section.style.setProperty(
              '--ak-carousel-line-2',
              carouselLine2 + 'px'
            );

            section.style.setProperty(
              '--ak-carousel-line-3',
              carouselLine3 + 'px'
            );

          }


          section.style.setProperty(
            '--ak-featured-title-full-width',
            titleFullWidth + 'px'
          );

          section.style.setProperty(
            '--ak-featured-title-text-width',
            titleTextWidth + 'px'
          );


          header.style.setProperty(
            '--ak-featured-link-text-width',
            linkTextWidth + 'px'
          );

          header.style.setProperty(
            '--ak-featured-link-arrow-width',
            linkArrowWidth + 'px'
          );

          header.style.setProperty(
            '--ak-featured-link-divider',
            linkTextWidth + 'px'
          );

          section.style.setProperty(
            '--ak-featured-link-text-width',
            linkTextWidth + 'px'
          );

          section.style.setProperty(
            '--ak-featured-link-arrow-width',
            linkArrowWidth + 'px'
          );

          section.style.setProperty(
            '--ak-featured-link-divider',
            linkTextWidth + 'px'
          );

          section.style.setProperty(
            '--ak-featured-explore-cross-x',
            (cartRect.right - cartRect.left) + 'px'
          );


          if (
            col1 > 0 &&
            col2 >= 0 &&
            col3 >= 0 &&
            col4 > 0
          ) {

            header.style.setProperty(
              '--ak-featured-header-col-1',
              col1 + 'px'
            );

            header.style.setProperty(
              '--ak-featured-header-col-2',
              col2 + 'px'
            );

            header.style.setProperty(
              '--ak-featured-header-col-3',
              col3 + 'px'
            );

            header.style.setProperty(
              '--ak-featured-header-col-4',
              col4 + 'px'
            );

            section.style.setProperty(
              '--ak-featured-header-col-1',
              col1 + 'px'
            );

            section.style.setProperty(
              '--ak-featured-header-col-2',
              col2 + 'px'
            );

            section.style.setProperty(
              '--ak-featured-header-col-3',
              col3 + 'px'
            );

            section.style.setProperty(
              '--ak-featured-header-col-4',
              col4 + 'px'
            );

          }


          startAkFeaturedViewAnimation(
            section
          );

        }
      );

  }


  function scheduleAkFeaturedHeaderNavSync() {

    requestAnimationFrame(
      function() {

        requestAnimationFrame(
          function() {

            syncAkFeaturedHeaderToNav();

          }
        );

      }
    );

  }


  function watchAkFeaturedReveal() {

    document
      .querySelectorAll(
        'section.ak-featured-carousel'
      )
      .forEach(
        function(section) {

          if (
            section.dataset.akViewRevealObserver ===
              'true'
          ) {
            return;
          }

          section.dataset.akViewRevealObserver =
            'true';


          var observer =
            new MutationObserver(
              function() {

                if (
                  !section.classList.contains(
                    'ak-images-visible'
                  )
                ) {
                  return;
                }


                /*
                  IMPORTANT:

                  Trigger the individual mobile section
                  directly when its reveal class appears.

                  Desktop continues through the existing
                  nav synchronization.
                */

                if (
                  window.matchMedia(
                    '(max-width: 1200px)'
                  ).matches
                ) {

                  startAkFeaturedViewAnimation(
                    section
                  );

                  return;
                }


                if (
                  hasAkFeaturedHeaderGeometry(
                    section
                  )
                ) {

                  startAkFeaturedViewAnimation(
                    section
                  );

                } else {

                  scheduleAkFeaturedHeaderNavSync();

                }

              }
            );


          observer.observe(
            section,
            {
              attributes: true,
              attributeFilter: [
                'class'
              ]
            }
          );


          if (
            section.classList.contains(
              'ak-images-visible'
            )
          ) {

            if (
              window.matchMedia(
                '(max-width: 1200px)'
              ).matches
            ) {

              startAkFeaturedViewAnimation(
                section
              );

            } else {

              scheduleAkFeaturedHeaderNavSync();

            }

          }

        }
      );

  }


  function initAkFeaturedNavSync() {

    watchAkFeaturedReveal();

    scheduleAkFeaturedHeaderNavSync();

    setTimeout(
      scheduleAkFeaturedHeaderNavSync,
      100
    );

    setTimeout(
      scheduleAkFeaturedHeaderNavSync,
      300
    );

    setTimeout(
      scheduleAkFeaturedHeaderNavSync,
      700
    );

    setTimeout(
      scheduleAkFeaturedHeaderNavSync,
      1500
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAkFeaturedNavSync
    );

  } else {

    initAkFeaturedNavSync();

  }


  window.addEventListener(
    'resize',
    scheduleAkFeaturedHeaderNavSync
  );


  document.addEventListener(
    'shopify:section:load',
    function() {

      setTimeout(
        initAkFeaturedNavSync,
        50
      );

    }
  );

})();


(function () {

  /* =====================================================
     PAPERS FRONT
     INITIAL CAROUSEL READY
  ===================================================== */

  var AK_FEATURED_HATCH_URL =
    'https://cdn.shopify.com/s/files/1/0475/3817/files/stroke-pattern-9.svg?v=1783539365';


  var akFeaturedHatchPromise =
    null;


  /* =====================================================
     CURRENT PAGE
  ===================================================== */

  function isAkFeaturedPapersFront() {

    var path =
      window.location.pathname
        .replace(
          /\/+$/,
          ''
        )
        .toLowerCase();


    return (
      path ===
      '/collections/papers-front'
    );

  }


  /* =====================================================
     PRELOAD HATCH
  ===================================================== */

  function preloadAkFeaturedHatch() {

    if (
      akFeaturedHatchPromise
    ) {
      return akFeaturedHatchPromise;
    }


    akFeaturedHatchPromise =
      new Promise(
        function (
          resolve
        ) {

          var image =
            new Image();


          var finished =
            false;


          function finish() {

            if (
              finished
            ) {
              return;
            }


            finished =
              true;


            resolve();

          }


          image.onload =
            finish;


          image.onerror =
            finish;


          image.src =
            AK_FEATURED_HATCH_URL;


          if (
            image.complete
          ) {

            finish();

          }


          /*
            SAFETY FALLBACK

            NEVER LEAVE THE CAROUSEL
            PERMANENTLY HIDDEN IF THE
            NETWORK FAILS.
          */

          setTimeout(
            finish,
            3000
          );

        }
      );


    return akFeaturedHatchPromise;

  }


  /* =====================================================
     CHECK SECTION GEOMETRY
  ===================================================== */

  function isAkFeaturedSectionGeometryReady(
    section
  ) {

    if (
      !section
    ) {
      return false;
    }


    /*
      STRUCTURAL GRID MUST BE BUILT.
    */

    if (
      !section.classList.contains(
        'is-ak-featured-grid-built'
      )
    ) {
      return false;
    }


    var header =
      section.querySelector(
        '.ak-featured-header'
      );


    var patternSlot =
      section.querySelector(
        '.ak-featured-header-pattern-slot'
      );


    var track =
      section.querySelector(
        '.splide__track'
      );


    if (
      !header ||
      !patternSlot ||
      !track
    ) {
      return false;
    }


    var headerRect =
      header.getBoundingClientRect();


    var patternRect =
      patternSlot.getBoundingClientRect();


    var trackRect =
      track.getBoundingClientRect();


    if (
      headerRect.width <=
        0 ||
      patternRect.width <=
        0 ||
      trackRect.width <=
        0
    ) {
      return false;
    }


    return true;

  }


  /* =====================================================
     REVEAL ONE CAROUSEL
  ===================================================== */

  function revealAkFeaturedInitialSection(
    section
  ) {

    if (
      !section ||
      section.classList.contains(
        'is-ak-featured-initial-ready'
      ) ||
      section.dataset.akFeaturedInitialRevealScheduled ===
        'true'
    ) {
      return;
    }


    section.dataset.akFeaturedInitialRevealScheduled =
      'true';


    /*
      FORCE FINAL HIDDEN LAYOUT FIRST.
    */

    section.offsetWidth;


    requestAnimationFrame(
      function () {

        requestAnimationFrame(
          function () {

            section.classList.add(
              'is-ak-featured-initial-ready'
            );


            section.dataset.akFeaturedInitialRevealScheduled =
              'false';

          }
        );

      }
    );

  }


  /* =====================================================
     WAIT FOR ONE CAROUSEL
  ===================================================== */

  function waitForAkFeaturedInitialSection(
    section
  ) {

    if (
      !section ||
      section.classList.contains(
        'is-ak-featured-initial-ready'
      )
    ) {
      return;
    }


    var startedAt =
      performance.now();


    function check() {

      if (
        section.classList.contains(
          'is-ak-featured-initial-ready'
        )
      ) {
        return;
      }


      if (
        isAkFeaturedSectionGeometryReady(
          section
        )
      ) {

        preloadAkFeaturedHatch()
          .then(
            function () {

              /*
                GIVE THE BROWSER TWO FRAMES
                TO COMMIT THE MASK IMAGE
                BEFORE THE SECTION BECOMES
                VISIBLE.
              */

              requestAnimationFrame(
                function () {

                  requestAnimationFrame(
                    function () {

                      revealAkFeaturedInitialSection(
                        section
                      );

                    }
                  );

                }
              );

            }
          );


        return;

      }


      /*
        KEEP WAITING FOR:

        - GRID BUILD
        - NAV GEOMETRY
        - SPLIDE WIDTH
      */

      if (
        performance.now() -
        startedAt <
        4000
      ) {

        requestAnimationFrame(
          check
        );


        return;

      }


      /*
        SAFETY FALLBACK.

        HATCH STILL GETS PRELOADED,
        BUT THE SITE CAN NEVER REMAIN
        HIDDEN FOREVER.
      */

      preloadAkFeaturedHatch()
        .then(
          function () {

            revealAkFeaturedInitialSection(
              section
            );

          }
        );

    }


    requestAnimationFrame(
      check
    );

  }


  /* =====================================================
     INIT
  ===================================================== */

  function initAkFeaturedInitialReady() {
    if (document.body.classList.contains('ak-papers-editorial-page')) return;

    if (
      !isAkFeaturedPapersFront()
    ) {
      return;
    }


    if (
      !window.matchMedia(
        '(min-width: 1201px)'
      ).matches
    ) {
      return;
    }


    /*
      START FETCHING THE HATCH
      IMMEDIATELY.
    */

    preloadAkFeaturedHatch();


    document
      .querySelectorAll(
        'section.ak-featured-carousel'
      )
      .forEach(
        function (
          section
        ) {

          waitForAkFeaturedInitialSection(
            section
          );

        }
      );

  }


  /* =====================================================
     DOM READY
  ===================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAkFeaturedInitialReady
    );

  } else {

    initAkFeaturedInitialReady();

  }


  /* =====================================================
     NAV GRID SYNC
  ===================================================== */

  window.addEventListener(
    'ak-nav-grid-synced',
    function () {

      requestAnimationFrame(
        initAkFeaturedInitialReady
      );

    }
  );


  window.addEventListener(
    'ak-bottom-nav-grid-synced',
    function () {

      requestAnimationFrame(
        initAkFeaturedInitialReady
      );

    }
  );


  /* =====================================================
     LOAD
  ===================================================== */

  window.addEventListener(
    'load',
    function () {

      requestAnimationFrame(
        initAkFeaturedInitialReady
      );

    }
  );


  /* =====================================================
     SHOPIFY EDITOR
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      requestAnimationFrame(
        function () {

          requestAnimationFrame(
            function () {

              initAkFeaturedInitialReady();

            }
          );

        }
      );

    }
  );

})();


(function () {

  if (
    !window.matchMedia(
      '(min-width: 1201px)'
    ).matches
  ) {
    return;
  }


  // Desktop Papers Front now reveals labels at their own line endpoints.
  if (document.body.classList.contains('ak-papers-editorial-page')) return;

  function getAkVpcompress22TargetCarousel(
    vpSection
  ) {

    if (
      !vpSection
    ) {
      return null;
    }


    var current =
      vpSection.closest(
        '.shopify-section'
      ) ||
      vpSection;


    var next =
      current.nextElementSibling;


    while (
      next
    ) {

      if (
        next.matches &&
        next.matches(
          'section.ak-featured-carousel.ak-papers-front-preexpanded'
        )
      ) {
        return next;
      }


      var carousel =
        next.querySelector
          ? next.querySelector(
              'section.ak-featured-carousel.ak-papers-front-preexpanded'
            )
          : null;


      if (
        carousel
      ) {
        return carousel;
      }


      next =
        next.nextElementSibling;

    }


    return null;

  }


  /* =====================================================
     PAPERS FRONT
     CAROUSEL 02+

     KEEP THE COMPLETE CAROUSEL
     HIDDEN UNTIL VPCOMPRESS22
     HAS MET IN THE CENTER.
  ===================================================== */

  document
    .querySelectorAll(
      '.ak-vpcompress22-desktop'
    )
    .forEach(
      function (
        vpSection
      ) {

        var carousel =
          getAkVpcompress22TargetCarousel(
            vpSection
          );


        if (
          !carousel
        ) {
          return;
        }


        carousel.classList.add(
          'ak-vpcompress22-carousel-waiting'
        );

      }
    );


  /* =====================================================
     VPCOMPRESS22 COMPLETE

     EXACT SEQUENCE:

     01
     VPCOMPRESS LINES MEET

     02
     COMPLETE CAROUSEL 02+
     FADES IN IMMEDIATELY

     03
     EXISTING DESKTOP COVER
     STARTS

     04
     EXISTING DOORS OPEN
     610MS LATER
  ===================================================== */

  window.addEventListener(
    'ak:vpcompress22-desktop-center-complete',
    function (
      event
    ) {

      var vpSection =
        event.detail
          ? event.detail.section
          : null;


      if (
        !vpSection
      ) {
        return;
      }


      var carousel =
        getAkVpcompress22TargetCarousel(
          vpSection
        );


      if (
        !carousel ||
        carousel.dataset.akVpcompress22CarouselReleased ===
          'true'
      ) {
        return;
      }


      carousel.dataset.akVpcompress22CarouselReleased =
        'true';


      /*
        FADE THE COMPLETE
        CAROUSEL IN NOW.
      */

      carousel.classList.add(
        'ak-vpcompress22-carousel-border',
        'ak-papers-front-preexpanded-visible'
      );


      /*
        START THE EXISTING
        CAROUSEL 02+ COVER SYSTEM.

        ITS PAPERS FRONT BRANCH
        WAITS 610MS BEFORE
        openCover().
      */

      openAkDesktopInitialCover(
        carousel
      );

    }
  );

})();


  (function () {
    if (window.akMobileViewportRevealInstalled) return;
    window.akMobileViewportRevealInstalled = true;

    var mobile = window.matchMedia('(max-width: 1200px)');
    var sections = new Set();
    var frame = 0;
    var generations = new WeakMap();

    function bind(section) {
      if (sections.has(section)) return;
      if(document.documentElement.classList.contains('ak-carousel-page-revisit')) {
        window.akCommitCarouselRevisit(section);
        sections.add(section);
        return;
      }
      if (section.hasAttribute('data-ak-mobile-stage')) {
        sections.add(section);
        return;
      }
      var top = section.querySelector('.ak-featured-mobile-topbar');
      var bottom = section.querySelector('.ak-featured-header');
      var cross = section.querySelector('.ak-first-mobile-image-cross');
      if (!top || !bottom || !cross) return;

      section.setAttribute('data-ak-mobile-stage', 'waiting');
      section.classList.add('ak-mobile-preexpanded-cross', 'ak-section-visible');
      section.classList.remove(
        'ak-mobile-bottom-ready', 'ak-mobile-cross-enter',
        'ak-mobile-cross-release', 'ak-mobile-cross-finished',
        'ak-mobile-cross-image-ready', 'ak-mobile-slide-hint-ready'
      );
      sections.add(section);
      if (document.body.classList.contains('ak-papers-mobile-revisit')) {
        section.classList.add('ak-mobile-bottom-ready');
        showImage(section);
      }
    }

    function showImage(section) {
      if (!section.isConnected) return;
      section.dataset.akMobileContentReady = 'true';
      section.classList.remove('ak-home-doors-held','ak-home-stage-hold');
      section.querySelectorAll('.ak-carousel-price-hidden,.ak-final-product-info-hidden').forEach(function (caption) {
        caption.classList.remove('ak-carousel-price-hidden','ak-final-product-info-hidden');
      });
      if (typeof window.akReleaseDeferredCarouselImages === 'function') window.akReleaseDeferredCarouselImages(section);
      var generation = generations.get(section);
      section.setAttribute('data-ak-mobile-stage', 'shown');
      if (section.classList.contains('ak-home-first-featured') && window.AK_FEATURED_VISIT) {
        window.AK_FEATURED_VISIT.markHomePlayed();
      }
      section.classList.add(
        'ak-images-visible', 'ak-mobile-cross-finished',
        'ak-mobile-cross-image-ready'
      );
      window.setTimeout(function () {
        if (generation !== generations.get(section)) return;
        section.classList.add('ak-mobile-slide-hint-ready', 'ak-mobile-reveal-complete');
      }, 200);
    }

    function releaseCross(section) {
      if (section.getAttribute('data-ak-mobile-stage') !== 'splitting') return;
      section.setAttribute('data-ak-mobile-stage', 'cross');
      var cross = section.querySelector('.ak-first-mobile-image-cross');
      var generation = generations.get(section);
      var remaining = new Set(cross.querySelectorAll('.ak-first-mobile-image-cross-line'));
      var finished = false;
      var fallback;

      function finish() {
        if (finished) return;
        finished = true;
        if (fallback) fallback.cancel();
        cross.removeEventListener('animationend', ended);
        if (generation === generations.get(section)) showImage(section);
      }
      function ended(event) {
        if (!/^akFirstFeaturedCross.*Out$/.test(event.animationName)) return;
        remaining.delete(event.target);
        if (!remaining.size) finish();
      }

      cross.addEventListener('animationend', ended);
      section.classList.add('ak-mobile-cross-release');
      // Existing cross animation lasts 580 ms.
      fallback = window.AKMobileMotion
        ? window.AKMobileMotion.after(finish, 700, section)
        : {cancel: (function (timer) { return function () { clearTimeout(timer); }; })(setTimeout(finish, 700))};
    }

    function splitTop(section, top) {
      if (top.hasAttribute('data-ak-mobile-editorial-title')) {
        section.setAttribute('data-ak-mobile-stage', 'splitting');
        releaseCross(section);
        return;
      }
      var generation = generations.get(section);
      var finished = false;
      var fallback;
      function finish() {
        if (finished) return;
        finished = true;
        if (fallback) fallback.cancel();
        top.removeEventListener('transitionend', ended);
        if (generation === generations.get(section)) releaseCross(section);
      }
      function ended(event) {
        if (event.target === top && event.propertyName === 'grid-template-columns') finish();
      }

      // Commit the closed grid before starting the existing 800 ms transition.
      top.getBoundingClientRect();
      top.addEventListener('transitionend', ended);
      section.setAttribute('data-ak-mobile-stage', 'splitting');
      fallback = window.AKMobileMotion
        ? window.AKMobileMotion.after(finish, 950, section)
        : {cancel: (function (timer) { return function () { clearTimeout(timer); }; })(setTimeout(finish, 950))};
    }

    function reachedTrigger(element, trigger) {
      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top <= trigger;
    }

    function update() {
      frame = 0;
      if (!mobile.matches) return;
      var trigger = (window.innerHeight || document.documentElement.clientHeight) * 0.99;
      if (document.querySelector('[data-ak-paper-mobile-intro]')) {
        var bottomMenu = document.querySelector('.ak-bottom-nav');
        if (bottomMenu) trigger = Math.min(trigger, bottomMenu.getBoundingClientRect().top - 1);
      }
      sections.forEach(function (section) {
        if (!section.isConnected) {
          sections.delete(section);
          return;
        }
        if (
          section.classList.contains('ak-home-first-featured') &&
          document.documentElement.classList.contains('ak-home-sticky-stage-enabled') &&
          !section.classList.contains('ak-home-stage-landed')
        ) {
          return;
        }
        // Once opened, an old resume/viewport listener cannot restart its intro.
        if (section.dataset.akMobileContentReady === 'true' &&
            section.getAttribute('data-ak-mobile-stage') !== 'shown') {
          section.classList.add('ak-mobile-bottom-ready');
          showImage(section);
          return;
        }
        if (document.body.classList.contains('ak-papers-mobile-intro-pending') &&
            section === document.querySelector('section.ak-featured-carousel')) return;
        var previousOwner = section.closest('.shopify-section')?.previousElementSibling;
        if (previousOwner?.querySelector('.ak-viewport-line-collapse')) previousOwner = previousOwner.previousElementSibling;
        var previousWheel = previousOwner?.querySelector('[data-ak-mobile-wheel]');
        if (previousWheel && previousWheel.dataset.akWheelReady !== 'true') return;
        var top = section.querySelector('.ak-featured-mobile-topbar');
        var bottom = section.querySelector('.ak-featured-header');
        // A skipped section must be open before the user scrolls back to it.
        if (section.getAttribute('data-ak-mobile-stage') !== 'shown' &&
            window.AKMobileMotion?.passed(section)) {
          generations.set(section, (generations.get(section) || 0) + 1);
          section.classList.add('ak-mobile-bottom-ready');
          showImage(section);
          return;
        }
        if (
          section.getAttribute(
            'data-ak-mobile-stage'
          ) === 'waiting' &&
          reachedTrigger(
            section.querySelector('.ak-astro-paper-heading') || top,
            trigger
          )
        ) {
          section.classList.add(
            'ak-mobile-bottom-ready'
          );

          splitTop(
            section,
            top
          );
        }
      });
    }

    function schedule() {
      if (!mobile.matches) return;
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function init() {
      if (!mobile.matches) return;
      document.querySelectorAll('section.ak-featured-carousel').forEach(bind);
      schedule();
    }

    window.addEventListener(
      'scroll',
      schedule,
      {
        passive: true,
        capture: true
      }
    );
    var mobileWasSuspended = document.hidden;
    var openedBeforeSuspend = new WeakSet();
    function captureMobileState() {
      if (!mobile.matches) return;
      sections.forEach(function (section) {
        var state = section.getAttribute('data-ak-mobile-stage');
        if (section.dataset.akMobileContentReady === 'true' || (state && state !== 'waiting'))
          openedBeforeSuspend.add(section);
      });
      mobileWasSuspended = true;
      cancelAnimationFrame(frame);frame=0;
    }
    function settleMobileResume() {
      if (!mobile.matches || document.hidden) return;
      init();
      sections.forEach(function (section) {
        var state = section.getAttribute('data-ak-mobile-stage');
        var wasOpen = section.dataset.akMobileContentReady === 'true' || openedBeforeSuspend.has(section);
        var rect = section.getBoundingClientRect();
        var inView = rect.width > 0 && rect.top < window.innerHeight && rect.bottom > 45;
        if (section.classList.contains('ak-home-first-featured') &&
            !section.classList.contains('ak-home-stage-landed')) return;
        if (!wasOpen && ((!state || state === 'waiting') || !inView)) return;
        generations.set(section, (generations.get(section) || 0) + 1);
        section.classList.add('ak-mobile-bottom-ready','ak-mobile-resume-settled');
        showImage(section);
      });
      schedule();
    }
    function queueMobileResume() {
      if (!mobile.matches || document.hidden) return;
      settleMobileResume();
      // Homepage and viewport restoration listeners can run later in the same
      // event. Reconcile their final frame without resetting the native track.
      requestAnimationFrame(function () { requestAnimationFrame(settleMobileResume); });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { captureMobileState(); return; }
      if (mobileWasSuspended) { mobileWasSuspended = false; queueMobileResume(); }
    });
    window.addEventListener('pagehide', captureMobileState);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted || mobileWasSuspended) { mobileWasSuspended = false; queueMobileResume(); }
    });
    window.addEventListener('ak:mobile-resume', queueMobileResume);
    window.addEventListener('ak:browser-resume',queueMobileResume);
    document.addEventListener('ak:mobile-wheel-ready', schedule);
    window.addEventListener('ak:mobile-home-opening-settled', function (event) {
      var section = event.detail.section;
      generations.set(section, (generations.get(section) || 0) + 1);
      section.setAttribute('data-ak-mobile-stage', 'shown');
      showImage(section);
      sections.add(section);
    });
    window.addEventListener('ak:home-sticky-stage-landed', schedule);
    window.addEventListener('ak:papers-mobile-prepare', function (event) {
      var section = event.detail.section;
      generations.set(section, (generations.get(section) || 0) + 1);
      section.setAttribute('data-ak-mobile-stage', event.detail.open ? 'shown' : 'waiting');
      sections.add(section);
    });
    window.addEventListener('ak:papers-mobile-landed', schedule);
    window.addEventListener('ak:global-frame-ready', schedule);
    window.addEventListener('pageshow', init);
    window.addEventListener('resize', init, { passive: true });
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('load', init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    }
    init();
  })();


(function () {
  function alignAkMobileFifthExploreSlides() {
    if (window.AK_NATIVE_ZOOM?.isZooming()) return;
    if (
      !window.matchMedia(
        '(max-width: 1200px)'
      ).matches
    ) {
      return;
    }

    document
      .querySelectorAll(
        'section.ak-featured-carousel'
      )
      .forEach(function (section) {
        var slide =
          section.querySelector(
            '[data-ak-mobile-fifth-explore].is-active.ak-mobile-fifth-explore-complete'
          );

        var track =
          section.querySelector(
            '.splide__track'
          );

        var list =
          section.querySelector(
            '.splide__list'
          );

        if (
          !slide ||
          !track ||
          !list
        ) {
          return;
        }

        var trackRect =
          track.getBoundingClientRect();

        var slideRect =
          slide.getBoundingClientRect();

        var offset =
          (
            trackRect.left +
            trackRect.right -
            slideRect.left -
            slideRect.right
          ) /
          2;

        if (
          Math.abs(offset) <
            0.25 ||
          Math.abs(offset) >
            6
        ) {
          return;
        }

        var transform =
          window.getComputedStyle(
            list
          ).transform;

        var currentX =
          0;

        if (
          transform &&
          transform !==
            'none'
        ) {
          try {
            var Matrix =
              window.DOMMatrix ||
              window.WebKitCSSMatrix;

            if (
              Matrix
            ) {
              currentX =
                new Matrix(
                  transform
                ).m41;
            } else {
              var values =
                transform
                  .replace(
                    /^matrix\(|\)$/g,
                    ''
                  )
                  .split(',');

              currentX =
                parseFloat(
                  values[4]
                ) ||
                0;
            }
          } catch (
            error
          ) {
            return;
          }
        }

        list.style.setProperty(
          'transition',
          'none',
          'important'
        );

        list.style.setProperty(
          'transform',
          'translate3d(' +
            (
              currentX +
              offset
            ) +
            'px, 0, 0)',
          'important'
        );
      });
  }

  function scheduleAkMobileFifthExploreAlignment() {
    if (window.AK_NATIVE_ZOOM?.isZooming()) return;
    if (!window.matchMedia('(max-width: 1200px)').matches) return;

    window.clearTimeout(
      window.akMobileFifthExploreAlignmentTimer
    );

    window.akMobileFifthExploreAlignmentTimer =
      window.setTimeout(
        function () {
          window.requestAnimationFrame(
            function () {
              window.requestAnimationFrame(
                alignAkMobileFifthExploreSlides
              );
            }
          );
        },
        120
      );
  }

  function bindAkMobileFifthExploreAlignment() {
    if (
      document.documentElement.dataset.akMobileFifthExploreAlignmentBound ===
        'true'
    ) {
      scheduleAkMobileFifthExploreAlignment();
      return;
    }

    document.documentElement.dataset.akMobileFifthExploreAlignmentBound =
      'true';

    window.addEventListener(
      'scroll',
      scheduleAkMobileFifthExploreAlignment,
      {
        passive:
          true
      }
    );

    window.addEventListener(
      'resize',
      scheduleAkMobileFifthExploreAlignment,
      {
        passive:
          true
      }
    );

    window.addEventListener(
      'orientationchange',
      scheduleAkMobileFifthExploreAlignment,
      {
        passive:
          true
      }
    );

    if (
      window.visualViewport
    ) {
      window.visualViewport.addEventListener(
        'resize',
        scheduleAkMobileFifthExploreAlignment,
        {
          passive:
            true
        }
      );

      window.visualViewport.addEventListener(
        'scroll',
        scheduleAkMobileFifthExploreAlignment,
        {
          passive:
            true
        }
      );
    }

    scheduleAkMobileFifthExploreAlignment();
  }

  function bindAkMobileFifthExploreCompletion() {
    if (
      !window.matchMedia(
        '(max-width: 1200px)'
      ).matches
    ) {
      return;
    }

    document
      .querySelectorAll(
        '[data-ak-mobile-fifth-explore]'
      )
      .forEach(function (slide) {
        if (
          slide.dataset.akExploreCompletionBound ===
          'true'
        ) {
          return;
        }

        slide.dataset.akExploreCompletionBound =
          'true';

        var completionTimer =
          null;

        function scheduleCompletion() {
          if (!slide.classList.contains('is-active')) {
            window.clearTimeout(completionTimer);
            completionTimer = null;
            return;
          }
          if (slide.classList.contains('ak-mobile-fifth-explore-complete') || completionTimer !== null) return;
          completionTimer = window.setTimeout(function () {
            completionTimer = null;
            if (!slide.classList.contains('is-active')) return;
            slide.classList.add('ak-mobile-fifth-explore-complete');
            scheduleAkMobileFifthExploreAlignment();
          },1500);
        }

        new MutationObserver(
          scheduleCompletion
        ).observe(
          slide,
          {
            attributes:
              true,
            attributeFilter:
              [
                'class'
              ]
          }
        );

        scheduleCompletion();
      });
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      bindAkMobileFifthExploreCompletion
    );
  } else {
    bindAkMobileFifthExploreCompletion();
  }

  bindAkMobileFifthExploreAlignment();
  ['load','pageshow','resize'].forEach(function (name) {
    window.addEventListener(name, bindAkMobileFifthExploreCompletion, {passive:true});
  });
  document.addEventListener('ak:carousel-covers-added', bindAkMobileFifthExploreCompletion);

  document.addEventListener(
    'shopify:section:load',
    function () {
      bindAkMobileFifthExploreCompletion();
      bindAkMobileFifthExploreAlignment();
    }
  );
})();

/* Match the footer arrow's vertical and horizontal clear space. */
(() => {
  const mobile = matchMedia('(max-width:1200px)');
  const installed = new WeakSet();
  function init() {
    document.querySelectorAll('section.ak-featured-carousel').forEach(section => {
      if (installed.has(section)) return;
      const arrow = section.querySelector('.ak-featured-header .ak-view-collection-arrow');
      const image = arrow?.querySelector('img');
      if (!image) return;
      installed.add(section);
      function measure() {
        if (!mobile.matches) return;
        const cell = arrow.getBoundingClientRect(), mark = image.getBoundingClientRect();
        if (!cell.width || !mark.width || !mark.height) return;
        const height = Math.ceil(cell.width - mark.width + mark.height + 1);
        const value = `${height}px`;
        if (section.style.getPropertyValue('--ak-mobile-carousel-footer-height') !== value)
          section.style.setProperty('--ak-mobile-carousel-footer-height',value);
      }
      new ResizeObserver(measure).observe(arrow);
      image.addEventListener('load',measure);
      mobile.addEventListener('change',measure);
      measure();
    });
  }
  init();
  document.addEventListener('shopify:section:load',init);
})();

/* Use the same heading reference on every page, not each page's local maximum. */
(() => {
  const mobile = matchMedia('(max-width:1200px)');
  const headings = ['Art papers','Arthletics','Artwork','Astrobear','Camera',
    'Graphic','Kingpong','New in','Papers','Sculptures','Troopers'];
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return;
  const observed = new WeakSet();
  let frame = 0;
  function fit() {
    frame = 0;
    if (!mobile.matches) return;
    const titles = [...document.querySelectorAll('[data-ak-mobile-editorial-title] .ak-featured-mobile-topbar-right')];
    const reference = titles.find(title => title.getBoundingClientRect().width > 0);
    if (!reference) return;
    const style = getComputedStyle(reference);
    context.font = `${style.fontWeight} 100px ${style.fontFamily}`;
    const candidates = headings.concat(titles.map(title => title.textContent.trim().replace(/\s+/g,' ')));
    const widest = Math.max(...candidates.map(text => {
      const metrics = context.measureText(text);
      return (metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight) || metrics.width;
    }));
    titles.forEach(title => {
      const section = title.closest('section.ak-featured-carousel');
      const width = title.getBoundingClientRect().width;
      if (!section || !width) return;
      const size = `${width * .7 * 100 / widest}px`;
      if (section.style.getPropertyValue('--ak-mobile-carousel-title-size') !== size)
        section.style.setProperty('--ak-mobile-carousel-title-size',size);
    });
  }
  function queue() { if (!frame) frame = requestAnimationFrame(fit); }
  const sizes = new ResizeObserver(queue);
  function init() {
    document.querySelectorAll('[data-ak-mobile-editorial-title]').forEach(title => {
      if (observed.has(title)) return;
      observed.add(title); sizes.observe(title);
    });
    queue();
  }
  init();
  if (document.fonts) {
    document.fonts.ready.then(queue);
    document.fonts.addEventListener('loadingdone',queue);
  }
  mobile.addEventListener('change',queue);
  window.addEventListener('pageshow',queue);
  document.addEventListener('shopify:section:load',init);
})();
